{
  "accountDropdown": {
    "changeAccount": "Change account",
    "filter": "Filter",
    "loading": "Loading",
    "profile": "Profile",
    "searchHotelPlaceholder": "Search hotel...",
    "title": "Account"
  },
  "action": {
    "decrease": "Decrease",
    "delete": "Delete",
    "duplicate": "Duplicate",
    "increase": "Increase",
    "rename": "Rename",
    "save": "Save",
    "saveChanges": "Save changes",
    "setAsDefault": "Set as default"
  },
  "activated": "Activated",
  "activityLog": {
    "affectedDate": "Affected date",
    "affectedDateTooltip": "Set Change time to “Last 6 months” to display all the logged changes for the selected Affected date.",
    "changeTime": "Change time",
    "date": "Date",
    "dateParsingError": "Failed to parse {count} date values with format {format}",
    "details": "Details",
    "emptyTable": "No items to display, try to increase the “Change time” date range to display more results.",
    "filenamePrefix": "activity-log",
    "loggedDatesTooltip": "Due to data protection regulations we delete logs after 6 months.",
    "logsChange": "Logs from-to",
    "maxExportElementsReached": "Too many items selected. Please adjust your filters to reduce the selection to under {max} items before exporting.",
    "ranges": {
      "dateParsingError": "Failed to parse {count} date values with format {format}",
      "last3Months": "Last 3 months",
      "last6Months": "Last 6 months",
      "last7Days": "Last 7 days",
      "lastMonth": "Last month",
      "resultsTitle": "Comparison results",
      "thisMonth": "This month"
    },
    "resultsTitle": "Comparison results",
    "schemaMapping": {
      "rateRulesV1": {
        "activate": "Rate rule \"{name}\" was activated.",
        "deactivate": "Rate rule \"{name}\" was deactivated.",
        "delete": "Rate rule \"{name}\" was deleted.",
        "edit": "Rate rule \"{name}\" was edited."
      },
      "ratesV1": {
        "rateFromTo": "from {rateFrom} to {rateTo}",
        "rateTo": "to {rateTo}"
      },
      "restrictionsV1": {
        "ctaAdded": "CTA added",
        "ctaRemoved": "CTA removed",
        "ctdAdded": "CTD added",
        "ctdRemoved": "CTD removed",
        "maxLos": "MaxLOS removed | MaxLOS to {n} | MaxLOS to {n}",
        "minLos": "MinLOS removed | MinLOS to {n} | MinLOS to {n}"
      },
      "resyncdataV1": {
        "error": "Rates and Restrictions have not been synchronized. Find more details in the error log on manage page.",
        "success": "Rates and Restrictions have been synchronized successfully for the next two years.",
        "trigger": "Resync was started. Process completion will be logged in a couple of minutes."
      }
    },
    "title": "Activity log",
    "tooManyLogs": "{number} more to show. Please specify affected date!",
    "type": "Type of change",
    "types": {
      "rateRules": "Rate Rules",
      "rates": "Rate",
      "restrictions": "Restrictions",
      "resyncdata": "Resync"
    },
    "typesPerContent": {
      "resyncdataV1": {
        "error": "Resync - error",
        "success": "Resync - success",
        "trigger": "Resync - trigger"
      }
    },
    "user": "User"
  },
  "add": "Add",
  "administration": {
    "connectivityStats": {
      "dpaAccepted": "DPA accepted",
      "excludeDpaNotAccepted": "DPA accepted",
      "exportExcel": "Excel (xlsx)",
      "id": "ID",
      "inboundChannel": "Inbound channel",
      "includeDemo": "Demo properties",
      "minimumLastReservationUpdates": "all|>1 day|>{count} days",
      "name": "Company name",
      "reservationUpdate": "Reservation update",
      "searchHotel": "Search hotel",
      "searchHotelPlaceholder": "Name, Id, ...",
      "title": "Connectivity stats"
    },
    "customerSuccessManagement": {
      "inventoryData": {
        "capacity": "Capacity",
        "occupancy": "Occupancy",
        "title": "Inventory"
      },
      "occupancyMatrix": {
        "title": "Occupancy"
      },
      "revenue": {
        "title": "Revenue forecast"
      },
      "seasons": {
        "defaultSeasons": "Default",
        "nSeasons": "Number of seasons",
        "nthSeason": "Season {nth}",
        "revenue": "Revenue",
        "showHistory": "Show historic data",
        "title": "Seasons"
      },
      "title": "Customer Success Management"
    },
    "hotelAdministration": {
      "back": "Back to Overview",
      "backHint": "No data to show for company with ID={companyId}. Please select another company.",
      "cm": "CM",
      "cofirmHubspot": "Confirm company information",
      "connectHubspot": "Connect",
      "createdOn": "Created date",
      "createHotel": "Add new company",
      "creationFlowModal": {
        "demoTitle": "Add new DEMO hotel - Step {step}",
        "productionTitle": "Add new hotel - Step {step}",
        "title": "Add new hotel"
      },
      "currency": "Currency",
      "demoHotel": "DEMO company",
      "details": "Company details",
      "dpaAccepted": "DPA",
      "edit": "Edit",
      "errorHandling": {
        "companyCreation": "Creating the company failed!",
        "unknownError": "Not handled error occured!"
      },
      "externalIds": "External IDs",
      "hotel": "Hotel",
      "hubspotConnectionFailed": "Connection to hubspot failed!",
      "hubspotId": "Hubspot ID",
      "id": "ID",
      "isActive": "Active",
      "name": "Company name",
      "noData": "No data to show",
      "notSet": "Not set",
      "pms": "PMS",
      "productionHotel": "Production company",
      "redirectModal": {
        "message": "You have unsaved changes which will be lost when clicking Proceed.",
        "proceed": "Proceed",
        "title": "Unsaved changes"
      },
      "searchHotel": "Search hotel",
      "searchHotelPlaceholder": "Name, Id, ...",
      "seeDetails": "See details",
      "systemConfiguration": "System configuration",
      "timeZone": "Time zone",
      "title": "Hotel administration",
      "titleFallbackEditor": "Hotel editor",
      "trustYouId": "TrustYou ID",
      "zipCountry": "Postal code, Country"
    },
    "inboundData": {
      "applyFilter": "Apply filter",
      "arrival": "Arrival",
      "booked": "Booked",
      "cancelled": "Cancelled",
      "comparison": {
        "downloadTemplate": "Download template",
        "error": {
          "dateParsingError": "Unable to parse {count} date(s). Please check that your date values are formatted correctly.",
          "generic": "We couldn't load the comparison results. Try again in a moment."
        },
        "instructions": {
          "fields": "date, revenue, rooms sold.",
          "intro": "Before uploading your file, note that:",
          "maxFileSize": " Maximum file size is 10 MB.",
          "requiredFields": " Your .csv or .xlsx file must contain the fields",
          "revenueFormat": " The revenue must be in the same format as specified in the template below."
        },
        "loading": "Fetching comparison results…",
        "startNewComparison": "Start new comparison",
        "step1": {
          "message": "Upload your file."
        },
        "step2": {
          "compare": "Compare",
          "excludedRooms": "Excluded rooms",
          "header": "Header is included in the file",
          "message": "Map all required fields.",
          "notMapped": "Not mapped",
          "settings": "Settings"
        },
        "table": {
          "date": "Date",
          "pmsRevenue": "PMS Revenue",
          "pmsRoomsSold": "PMS Rooms Sold",
          "rbRevenue": "RB Revenue",
          "rbRoomsSold": "RB Rooms Sold",
          "revenueDiff": "Revenue Diff.",
          "roomsSoldDiff": "Rooms Sold Diff."
        }
      },
      "confirmed": "Confirmed",
      "creation": "Creation",
      "dataTableColumnTitle": {
        "arrivalDate": "Arrival date",
        "blockedUnits": "Blocked units",
        "blockedUntil": "Blocked until",
        "blockId": "Block ID",
        "channel": "Channel",
        "countryCode": "Country Code",
        "creationDate": "Creation date",
        "departureDate": "Departure date",
        "excluded": "Excluded",
        "isRoom": "Is room",
        "mainResId": "Main ResID",
        "name": "Name",
        "numberOfAdults": "Number adults",
        "numberOfChildren": "Number children",
        "numberOfInfants": "Number infants",
        "pickedUnits": "Picked units",
        "ratePlanCode": "Rate Plan Code",
        "remainingUnits": "Remaining units",
        "reservationId": "External Res ID",
        "roomNumber": "Room number",
        "roomType": "Room type",
        "segment": "Segment",
        "status": "Status",
        "total": "Total"
      },
      "dataTabs": {
        "roomStats": {
          "description": "Room stats re-computation",
          "recompute": "Re-compute"
        },
        "title": {
          "blocks": "Blocks",
          "comparison": "Compare reservations",
          "inventory": "Inventory",
          "reservations": "Reservations",
          "roomStats": "Room Stats"
        }
      },
      "delete": "Delete",
      "deleteAll": "All",
      "deleteFiltered": "Filtered",
      "deleteSelected": "Selected",
      "departure": "Departure",
      "filterDropdown": {
        "noneSelected": "None",
        "selected": "{count} selected"
      },
      "filters": {
        "blockId": "Block ID",
        "channel": "Channel",
        "dateBy": "Filter dates by",
        "dateRange": "Date Range",
        "excludedRooms": "Excluded Rooms",
        "filter": "Filter",
        "reservationId": "Reservation ID",
        "roomType": "Room Type",
        "segment": "Segment",
        "status": "Status"
      },
      "hide": "Hide",
      "inboundData": "Inbound Data",
      "inventory": {
        "blocked": "Blocked (Block Available)",
        "date": "Date",
        "excluded": "Excluded",
        "outOfOrder": "Out Of Order",
        "physical": "Physical",
        "roomType": "Room Type"
      },
      "modal": {
        "cleanAll": {
          "message": "In order to delete the reservations, please type the following text in the input field below: {companyName}",
          "title": "Delete Reservations"
        },
        "cleanFiltered": {
          "message": {
            "blocks": "Are you sure that you want to clean the filtered blocks? This will lead to the deletion of all blocks that match the set filters.",
            "reservations": "Are you sure that you want to clean the filtered reservations? This will lead to the deletion of all reservations that match the set filters including all their rooms"
          },
          "title": {
            "blocks": "Clean blocks",
            "reservations": "Clean filtered reservations"
          }
        },
        "cleanSelected": {
          "message": {
            "blocks": "Are you sure that you want to clean the selected blocks?",
            "reservations": "Are you sure that you want to clean the selected reservations?"
          },
          "title": {
            "blocks": "Clean blocks",
            "reservations": "Clean Reservations"
          }
        }
      },
      "noShow": "No Show",
      "option": "Option",
      "optionNoDeduction": "Option no deduction",
      "reservationsImport": {
        "addToDatabase": "Add to Database",
        "cancelImport": "Cancel Import",
        "errorMessage": "Reservations could not be uploaded. Please try again later.",
        "step1": {
          "downloadTemplate": "Download Template",
          "message1": "Before uploading your file, note that:",
          "message2": {
            "part1": "Your .csv file must contain the fields ",
            "part2": "reservation id, number of adults, number of children, room type, booking date, check in date, check out date, status and total amount."
          },
          "message3": "Values for the fields that contains date, amount or status have to be in the same format as we specified in our template.",
          "message4": "After the file is uploaded, please map all required fields."
        },
        "step2": {
          "import": "Import",
          "invalidData": "Invalid value \"{value}\" found in field \"{field}\". In case your file contains headers please check the \"Header is included in the file\" checkbox.",
          "message": "Map all required fields. When done, review the data and merge with the database.",
          "notMapped": "Not Mapped",
          "settings": {
            "message": "Header is included in the file",
            "title": "Settings"
          }
        },
        "successMessage": "Reservations uploaded successfully.",
        "title": "Import Reservations"
      },
      "show": "Show",
      "status": "Status",
      "stay": "Stay"
    },
    "userManagement": {
      "aboutUser": "ABOUT USER",
      "addNewUser": "Add new user",
      "addUser": "Add user",
      "adminPermissions": "ADMIN PERMISSIONS",
      "admins": "ADMINS",
      "areYouSureThatYouWantToRemoveCompany": "Are you sure that you want to remove {firstname} {lastname} from company {companyName} ({companyId})?",
      "assignCompany": "ASSIGN COMPANY",
      "assignedCompanies": "ASSIGNED COMPANIES",
      "assignNewCompany": "ASSIGN NEW COMPANY",
      "backToUsers": "Back to Users",
      "beCareful": "Be careful",
      "cancelled": "Cancelled",
      "changeStatus": "Change Status",
      "changeStatusConfirmation": "Are you sure that you want to {action} {fullname}?",
      "companies": "Hotels",
      "company": "Hotel",
      "companyCount": "Companies count",
      "customers": "CUSTOMERS",
      "definite": "Definite",
      "delete": "DELETE",
      "disable": "Disable",
      "disabled": "Disabled",
      "disableWarningMessage": "if you disable this account, the user will not be able to login in to RateBoard anymore. You can revert this action later.",
      "email": "E-mail",
      "enable": "Enable",
      "enabled": "Enabled",
      "error": {
        "duplicateEmail": "User with E-mail already exists",
        "existingInvitation": "User has already been invited.",
        "existingInvitationToCompany": "User has already been invited to this hotel.",
        "fillAll": "Please fill out all fields."
      },
      "expired": "Expired",
      "firstname": "First Name",
      "id": "ID",
      "language": "Language",
      "lastname": "Last Name",
      "loading": "Loading...",
      "makeAdminWarning": " enabling admin permissions allows the user to access and make changes to all accounts. Make sure you selected the correct user before proceeding.",
      "manageAdmins": "MANAGE ADMINS",
      "manageAdminsModal": "Manage Admins",
      "mfaRequired": "2FA",
      "none": "None",
      "openInvite": "OPEN INVITE",
      "openInvites": "Open Invites",
      "prospect": "Prospect",
      "rateboardUsers": "RateBoard Users",
      "remove": "REMOVE",
      "removeCompany": "Remove company",
      "resendInvite": "RESEND INVITE",
      "role": "ROLE",
      "searchFor": "Search for",
      "searchPlaceholder": "Search...",
      "seeAll": "See all",
      "selectCompany": "Select company",
      "selectUser": "Select a user you would like to make an ADMIN",
      "sendInvite": "Send Invite",
      "status": "STATUS",
      "statusHeader": "Status",
      "user": "User",
      "userId": "User ID",
      "username": "Username",
      "users": "Users"
    }
  },
  "alert": {
    "message": {
      "error": "Something went wrong.",
      "success": "Your request was processed successfully."
    },
    "title": {
      "error": "Error!",
      "success": "Success!"
    }
  },
  "analyse": {
    "comparison": {
      "chartTitles": {
        "occupancy": "Development Occupancy",
        "revenue": "Development Revenue"
      },
      "filters": {
        "label": {
          "main": "Main date range",
          "reference": "Reference date range"
        }
      },
      "occupancyChart": {
        "tooltip": {
          "daysBeforeEnd": "Days before end",
          "dba": "DBA",
          "occupancy": "Occupancy"
        }
      },
      "revenueChart": {
        "tooltip": {
          "adr": "ADR",
          "daysBeforeEnd": "Days before end",
          "dba": "DBA",
          "revenue": "Revenue",
          "revPar": "RevPar"
        }
      },
      "slider": {
        "adr": "ADR",
        "occupancy": "Occupancy",
        "revPar": "RevPAR"
      },
      "table": {
        "adr": "@:analyse.filters.kpi.adr",
        "adrReference": "@:analyse.filters.kpi.adr Ref.",
        "daysBeforeEndDate": "Days before end-date",
        "dba": "DBA",
        "occupancy": "@:analyse.filters.kpi.occupancy",
        "occupancyReference": "@:analyse.filters.kpi.occupancy Ref.",
        "revenue": "@:analyse.filters.kpi.revenue",
        "revenueReference": "@:analyse.filters.kpi.revenue Ref.",
        "revpar": "@:analyse.filters.kpi.revpar",
        "revparReference": "@:analyse.filters.kpi.revpar Ref."
      },
      "title": "Comparison",
      "tooltips": {
        "charts": {
          "occupancy": "Development of occupancy over time up to the specified last day of the period.",
          "revenue": "Development of revenue KPIs over time up to the specified last day of the period."
        },
        "infoTiles": {
          "adr": "Current average ADR (Average Daily Rate) for the selected main period. Additionally, you can see the difference to the selected reference period.",
          "forecast": "The forecast for the total number of rooms expected to be sold and occupancy during the main date range (if it is in the future). The forecast is generated for the next 12 months and is available if sufficient data is available.",
          "occupancy": "Current occupancy for the selected main date range (total number of rooms and average occupancy in %). Additionally, you can see the difference to the selected reference date range.",
          "revenue": "Current total revenue for the selected main date range. Additionally, you can see the difference to the selected reference date range.",
          "revPar": "Current average RevPar (Revenue Per Available Room) for the selected main period. Additionally, you can see the difference to the selected reference period.",
          "vacantRooms": "Total number of rooms still available for the selected main date range. Additionally, you can see the difference to the selected reference date range."
        }
      }
    },
    "filters": {
      "distribution": {
        "channels": "Channels",
        "countries": "Countries",
        "room_category": "Room Category",
        "room_type": "Room Type",
        "segment_categories": "Segment Categories",
        "segments": "Segments"
      },
      "filter": {
        "austria": "Austria",
        "channels": "CHANNELS",
        "complimentary": "Complimentary",
        "countries": "COUNTRIES",
        "group": "Groups",
        "not_set": "None",
        "pickup": "PICKUP",
        "pickup_14days": "14 Days",
        "pickup_1day": "1 Day",
        "pickup_30days": "30 Days",
        "pickup_3days": "3 Days",
        "pickup_60days": "60 Days",
        "pickup_7days": "7 Days",
        "pickup_90days": "90 Days",
        "pms_data_channels": "PMS Data",
        "pms_data_segments": "PMS Data",
        "room_categories": "ROOM CATEGORIES",
        "room_types": "ROOM TYPES",
        "room_x": "ROOM X",
        "room_z": "ROOM Z",
        "segment_categories": "SEGMENT CATEGORIES",
        "segments": "SEGMENTS",
        "standard": "Standard",
        "suite": "Suite"
      },
      "kpi": {
        "adr": "ADR",
        "occupancy": "Occupancy",
        "revenue": "Revenue",
        "revpar": "RevPAR"
      },
      "labels": {
        "distribution": "Distribution",
        "filter": "Filter",
        "kpi": "KPI",
        "reference1": "1st Reference",
        "reference2": "2nd Reference"
      },
      "reference": {
        "budget": "BUDGET",
        "final_2_years_ago": "FINAL 2 YEARS AGO",
        "final_2_years_ago_same_date": "Same Date final 2Y",
        "final_2_years_ago_same_day_week": "Same Weekday final 2Y",
        "final_last_year": "FINAL LAST YEAR",
        "final_last_year_same_date": "Same Date final 1Y",
        "final_last_year_same_day_week": "Same Weekday final 1Y",
        "same_date": "Same Date",
        "same_day_week": "Same Day of Week",
        "same_time_2_years_ago": "SAME TIME 2 YEARS AGO",
        "same_time_2_years_ago_same_date": "Same Date YTD 2Y",
        "same_time_2_years_ago_same_day_week": "Same Weekday YTD 2Y",
        "same_time_last_year": "SAME TIME LAST YEAR",
        "same_time_last_year_same_date": "Same Date YTD 1Y",
        "same_time_last_year_same_day_week": "Same Weekday YTD 1Y",
        "show_budget": "Show Budget"
      }
    },
    "hotel": {
      "analyseChart": {
        "legend": {
          "bar": {
            "pickup": {
              "cancellations": "Cancelled",
              "confirmations": "Confirmed",
              "otb": "OTB"
            },
            "reference1": "(1st Reference)",
            "reference2": "(2nd Reference)"
          },
          "budget": "Budget",
          "event": {
            "primary": "Event",
            "reference1": "Event (1st Reference)",
            "reference2": "Event (2nd Reference)"
          },
          "forecast": "{kpi} Forecast",
          "forecastTooltip": "Forecast for the next 12 months is only displayed if the data basis is sufficient according to superior criteria. The shading behind the line represents the probable fluctuation range in the forecast.",
          "line": {
            "primary": "Active Rate",
            "reference1": "Active Rate (1st Reference)",
            "reference2": "Active Rate (2nd Reference)"
          }
        },
        "noData": "No data available",
        "showSentRate": "Show active rate"
      },
      "detail": {
        "header": "@:analyse.hotel.detail.headerNoReference compared to <b>{referenceDate}</b>",
        "headerNoReference": "Details for <b>{date}</b>",
        "headerWithSecond": "@:analyse.hotel.detail.header and <b>{secondReferenceDate}</b>",
        "placeholder": "Select a date on the chart below to see more details.",
        "tooltip": {
          "developmentChart": "Development of KPIs over time depending on the DBA (days before arrival).",
          "rateUpdatesChart": "Active rates (those that were actually sent) over time per room category."
        }
      },
      "developmentChart": {
        "availableRooms": "Available rooms",
        "availableRooms1": "Available rooms (@:analyse.hotel.gridItems.reference1)",
        "availableRooms2": "Available rooms (@:analyse.hotel.gridItems.reference2)",
        "forecast": "Forecast",
        "roomsSold": "Rooms sold",
        "roomsSold1": "Rooms sold (@:analyse.hotel.gridItems.reference1)",
        "roomsSold2": "Rooms sold (@:analyse.hotel.gridItems.reference2)",
        "title": "Development",
        "tooltip": {
          "adr": "@:analyse.filters.kpi.adr",
          "availableRooms": "Available rooms",
          "dba": "DBA",
          "occupancy": "@:analyse.filters.kpi.occupancy",
          "revenue": "@:analyse.filters.kpi.revenue",
          "revPar": "@:analyse.filters.kpi.revpar",
          "roomsSold": "Rooms sold"
        },
        "vacantRooms": "Vacant rooms"
      },
      "gridItems": {
        "adr": "@:analyse.filters.kpi.adr",
        "availableRooms": "Available rooms",
        "forecast": "Forecast",
        "occupancy": "@:analyse.filters.kpi.occupancy",
        "reference1": "1st Reference",
        "reference2": "2nd Reference",
        "revenue": "@:analyse.filters.kpi.revenue",
        "revPar": "@:analyse.filters.kpi.revpar",
        "roomNights": "Room nights"
      },
      "indicator": "Details above",
      "infoTiles": {
        "adr": "Current ADR (Average Daily Rate) for the selected date. Additionally, you can see the difference to the value in the last year.",
        "noData": "No data available",
        "tooltip": {
          "forecast": "The forecast for the selected day is available for KPIs revenue and occupancy (expected sold rooms) if sufficient data is available. Forecast is generated for the next 12 months.",
          "forecastNoData": "Forecast not computed for the past",
          "revenue": "Current revenue for the selected date. Additionally, you can see the difference to the selected reference.",
          "revpar": "Current RevPAR (Revenue Per Available Room) for the selected date. Additionally, you can see the difference to the selected reference.",
          "roomsSold": "Current occupancy for the selected date. Additionally, you can see the difference to the selected reference.",
          "vacantRooms": "Number of rooms still available for the selected date. Additionally, you can see the difference to the selected reference."
        }
      },
      "rateUpdatesChart": {
        "title": "Rate Updates"
      },
      "showSentRate": "Show active rate",
      "title": "Hotel Data",
      "tooltip": {
        "budget": "Budget",
        "forecast": "Forecast",
        "lastRateSent": "Active rate",
        "total": "Total"
      }
    },
    "table": {
      "activeRate": "Active rate",
      "date": "Date",
      "firstDifference": "1st Difference",
      "firstReference": "@:analyse.filters.labels.reference1",
      "secondDifference": "2nd Difference",
      "secondReference": "@:analyse.filters.labels.reference2",
      "summary": "Summary",
      "total": "Total"
    }
  },
  "assistant": {
    "actions": {
      "cancel": "Cancel",
      "close": "Close",
      "collapse": "Collapse",
      "delete": "Delete",
      "download": "Export",
      "edit": "Edit",
      "expand": "Expand",
      "newChat": "New chat",
      "rename": "Rename",
      "submit": "Submit",
      "update": "Update"
    },
    "chat": {
      "actions": {
        "send": "Send",
        "sending": "Sending..."
      },
      "disclaimer": {
        "linkText": "This is AI.",
        "text": "It can make mistakes and doesn't see everything — verify information and use your own judgement."
      },
      "emptyState": {
        "descriptions": {
          "first": "The AI Revenue Manager analyzes your data, forecasts, the market and more to help you make smarter revenue decisions — think of it as a sparring partner delivering insigts and revenue recommendations.",
          "fourth": "You stay in control — the AI Revenue Manager won't make changes in RateBoard on its own. Every action is yours to apply.",
          "second": "You know your property best. The AI Revenue Manager works with the data available to it and won't always see everything relevant to your house but aims to be accurate.",
          "third": "Ask for a table or chart anytime to visualize the data behind a recommendation."
        }
      },
      "message": {
        "chart": {
          "legend": {
            "clickToHide": "Click to hide",
            "clickToShow": "Click to show"
          }
        },
        "download": {
          "chart": {
            "png": "Download as PNG"
          },
          "table": {
            "csv": "Download as CSV"
          }
        },
        "error": {
          "actions": {
            "retryPrevious": "Resend previous question"
          },
          "descriptions": {
            "tooManyPendingMessages": "The AI Revenue Manager is still working through your other open conversations. Give it a moment, then send your message again.",
            "unknownError": "The AI Revenue Manager couldn't answer right now due to a technical issue. Please wait a moment and try again. If this keeps happening, please contact support."
          },
          "titles": {
            "tooManyPendingMessages": "Too many questions pending",
            "unknownError": "Technical issue"
          }
        },
        "errorNote": {
          "error": "The request was not processed due to an error.",
          "usageLimit": "Available usage limit was reached."
        },
        "exportMessage": "Export conversation",
        "feedback": {
          "placeholderDown": "What was inaccurate or unhelpful?",
          "placeholderUp": "What made this useful? (optional)",
          "thumbsDown": "Thumbs down",
          "thumbsUp": "Thumbs up",
          "title": "Your Feedback"
        },
        "loadingMessages": "Loading messages ...",
        "pending": {
          "pending": "Message received — queued for the AI Revenue Manager.",
          "phase": {
            "callingAgent": "Thinking...",
            "createMessage": "Initializing...",
            "processTool": "Analyzing data...",
            "scheduleMessage": "Queueing request...",
            "synthesizingResponse": "Finishing up..."
          },
          "thinking": "The AI Revenue Manager is working on your request now. Analyzing...",
          "thinkingTakesLonger": "Still analyzing — the more data involved, the longer a solid answer takes. Step away if you like; your answer will be waiting.",
          "tool": {
            "citeKnowledgeSource": "Noting down knowledge sources...",
            "getAnalyseStats": "Checking OTB performance stats...",
            "getCapacity": "Checking overall hotel capacity...",
            "getCategoryNames": "Looking up category names...",
            "getClosedDays": "Checking for closed days...",
            "getCurrentDateTime": "Checking the current hotel local time...",
            "getCurrentWeather": "Checking the current weather...",
            "getEvents": "Looking up events...",
            "getFilterValues": "Retrieving available filter options...",
            "getForecasterCompany": "Checking forecast configuration...",
            "getFullMessageContent": "Reading full message history...",
            "getFutureWeather": "Checking the weather forecast...",
            "getLastSentRates": "Looking up active rates...",
            "getMarketOccupancyComparisonStats": "Comparing market occupancy performance...",
            "getMarketPickupComparisonStats": "Comparing market pickup and cancellation trends...",
            "getOccupancyForecast": "Checking the occupancy forecast...",
            "getPickupDevelopmentStats": "Analyzing pickup and cancellation trends...",
            "getPickupStats": "Checking pickup and cancellation stats...",
            "getRatesToConfirm": "Gathering rate recommendations waiting for confirmation...",
            "getRecommendedRates": "Checking recommended rate options...",
            "getRegionForecast": "Checking regional forecast details...",
            "getRevenueForecast": "Checking the revenue forecast...",
            "getRoomTypeNames": "Looking up room type names...",
            "getShiftedDateOnSameDay": "Calculating the corresponding date...",
            "getShiftedDateOnSameWeekday": "Finding the matching day of the week...",
            "getShiftedDatePeriod": "Adjusting the date range...",
            "loadFullSkill": "Reviewing the steps for this task...",
            "resolveObservationDate": "Pinpointing the exact observation date..."
          }
        },
        "printSender": {
          "assistant": "AI Revenue Manager",
          "system": "System"
        },
        "toggle": {
          "chart": "chart",
          "hide": "Hide {label}",
          "show": "Show {label}",
          "sources": "related Knowledge Base Articles",
          "table": "table"
        }
      },
      "notEnoughCredits": {
        "inactiveTier": "You're using RateBoard {tier} - RateBoard without the AI Revenue Manager. If you'd like to use it, {sendUsARequest} and we'll find the right setup for your property.",
        "inactiveTierTitle": "Your plan doesn't include AI credits",
        "moreCredits": "More credits will be available on <b>{date}</b>, and you can pick up right where you left off.",
        "moreCreditsDaily": "More credits will be available <b>tomorrow</b>, and you can pick up right where you left off.",
        "needMoreAiCredits": "Need more AI credits?",
        "requestItNow": "Request it now.",
        "sendUsARequest": "send us a request",
        "title": "You've reached your available usage limit",
        "youveUsedAllYourCredits": "You've used all your available credits for today."
      },
      "prompt": {
        "placeholder": "Type your message here..."
      },
      "responseFormat": {
        "label": "Reply as"
      },
      "suggestions": {
        "mobileMenuLabel": "Popular questions"
      }
    },
    "conversation": {
      "dateLabels": {
        "today": "Today"
      },
      "editPlaceholder": "Enter new conversation title",
      "loadingMore": "Loading more...",
      "loadMore": "Load more"
    },
    "conversations": "Conversations",
    "creditUsage": {
      "adminOnlyInfo": "RateBoard Mode · Free usage",
      "availableCredits": "Available credits",
      "dripBoost": {
        "daily": "Daily boost",
        "weekly": "Weekly boost"
      },
      "noCreditsInThisTier": "No AI credits in {tier}",
      "ofMonthlyCreditsUsed": "of monthly credits used",
      "requestAiManager": "Request the AI Revenue Manager",
      "requestItNow": "Request it now",
      "requestMoreCredits": "Need more AI credits?",
      "requestUsage": "Need AI usage?",
      "tiers": {
        "custom": "Custom",
        "disabled": "Performance",
        "smart": "Smart"
      },
      "tooltip": {
        "availableCreditsDescription": "Credits currently ready to use.",
        "description": "The amount of available credits is based on your plan.",
        "dripDescription": {
          "daily": "Credits included in your plan that become available automatically each day.",
          "weekly": "Credits included in your plan that become available automatically each week."
        },
        "title": "Usage explained",
        "usedCreditsDescription": "Credits spent this month."
      },
      "usage": "Usage",
      "usedCredits": "Used credits"
    },
    "icon": {
      "label": "AI"
    },
    "modal": {
      "delete": {
        "message": "Delete \"{title}\"? This action cannot be undone.",
        "title": "Delete conversation"
      },
      "edit": {
        "title": "Edit conversation title"
      }
    },
    "untitled": "Untitled"
  },
  "back": "Back",
  "benchmarking": {
    "cancellationChart": {
      "title": "Cancellation"
    },
    "chartHeader": {
      "inMonth": "in {month}",
      "legacyMonthPrefix": "in",
      "lessThanMarket": "{value}% less than market",
      "moreThanMarket": "{value}% more than market",
      "thisMonth": "this month",
      "tooltip": {
        "adr": {
          "description": "This chart shows the average daily rate per month, for the past and future 6 months, and compares it to the market’s average. Click on a month to show day per day data."
        },
        "cancellation": {
          "description": "This chart shows the cancellation per month, for the past 12 months, and compares it to the market’s average. Click on a month to show day per day data.",
          "title": "Cancellation"
        },
        "occupancy": {
          "description": "This chart shows the total occupancy per month, for the past and future 6 months, and compares it to the market’s average. Click on a month to show day per day data.",
          "title": "Occupancy"
        },
        "pickup": {
          "description": "This chart shows the net pickup (pickup - cancellation) per month, for the past 12 months, and compares it to the market’s average. Click on a month to show day per day data.",
          "title": "PickUp"
        },
        "pickupAndCancellation": {
          "description": "This chart shows the total pickup and cancellation for the last 30 days, and compares it to the market’s average. ",
          "title": "Pickup and Cancellation"
        },
        "revpar": {
          "description": "This chart shows the average RevPAR per month, for the past and future 6 months, and compares it to the market’s average. Click on a month to show day per day data."
        },
        "stayDays": {
          "description": "This chart shows the distribution of the last 30 days pickup and cancellation, and compares it to the market’s average.",
          "title": "Stay Dates"
        }
      }
    },
    "chartLabels": {
      "currentMonth": "Current Month",
      "market": "Market",
      "yourCompany": "Your Hotel"
    },
    "description": {
      "message1": "Use the filters ",
      "message2": "Region, Star Category, Hotel Focus",
      "message3": " (e.g., Wellness, Family, …) and ",
      "message4": "Hotel Type",
      "message5": " (Business and/or Leisure) to define your comparison group.",
      "message6": "Don't just look at your immediate geographic area; also include similar hotel types in other comparable regions",
      "message7": " – this way, you'll get more meaningful and fair benchmarks for your hotel. The data pool should be as large as possible, while maintaining the highest possible homogeneity.",
      "title1": "IMPORTANT INFORMATION!",
      "title2": "How to select your market:"
    },
    "dualTooltip": {
      "company": "Your Hotel",
      "market": "Market"
    },
    "infoTile": {
      "averageRateIndex": {
        "indicatorValue": "@:benchmarking.infoTile.rateGenerationIndex.indicatorValue",
        "title": "Average Rate Index",
        "tooltip": {
          "description": "This card shows the hotel’s ADR deviation compared to the market’s average. ARI = Hotel’s ADR / Market’s average ADR",
          "title": "Average Rate Index"
        },
        "underline": "@:benchmarking.infoTile.rateGenerationIndex.underline"
      },
      "lastMinutePickup": {
        "indicatorValue": {
          "decrease": "@:benchmarking.infoTile.pickup.indicatorValue.decrease",
          "increase": "@:benchmarking.infoTile.pickup.indicatorValue.increase"
        },
        "title": "Last minute Pickup",
        "underline": "roomnights booked during last 2 weeks for upcoming 2 weeks "
      },
      "marketPenetrationIndex": {
        "indicatorValue": "@:benchmarking.infoTile.rateGenerationIndex.indicatorValue",
        "title": "Market Penetration Index",
        "tooltip": {
          "description": "This card shows the hotel’s occupancy deviation compared to the market’s average. MPI = Hotel’s Occupancy rate / Market’s average occupancy rate * 100",
          "title": "Market Penetration Index"
        },
        "underline": "@:benchmarking.infoTile.rateGenerationIndex.underline"
      },
      "pickup": {
        "indicatorValue": {
          "decrease": "{n}% less than market",
          "increase": "{n}% more than market"
        },
        "title": "Pickup",
        "underline": "Last 2 weeks"
      },
      "rateGenerationIndex": {
        "indicatorValue": "{s} this calendar year",
        "title": "Rate Generation Index",
        "tooltip": {
          "description": "This card shows the hotel’s RevPAR deviation compared to the market’s average. RGI = Hotel’s RevPAR / Market’s average RevPAR.",
          "title": "Rate Generation Index"
        },
        "underline": "this calendar month"
      },
      "roomNights": "Room nights",
      "trendingMonth": {
        "indicatorValue": "{d} for the market",
        "title": "Trending Month",
        "underline": "{n} room nights booked in the last 2 weeks"
      }
    },
    "last30Days": "Last 30 days",
    "marketFilter": {
      "applyFilters": "Apply filters",
      "comparedTo": {
        "comparedTo": "Compared to",
        "country": "Hotel's country",
        "district": "Hotel's district",
        "group": {
          "country": "COUNTRY",
          "district": "DISTRICT",
          "state": "STATE",
          "zipCode": "ZIPCODE"
        },
        "state": "Hotel's state",
        "zipCode": "Hotel's zip code"
      },
      "hotelsFocus": "Hotel's Focus",
      "hotelsType": "Hotel's Type",
      "stars": "Stars",
      "tooLittleData": "Not enough market data available, try expanding your filter selection."
    },
    "newUi": {
      "advancedMode": "Advanced mode",
      "advancedModeExplanation": "Use the filters below to define your comparison group. The data pool should be as large as possible, while maintaining the highest possible homogeneity. For example also include similar hotel types in other comparable regions.",
      "country": "Country",
      "district": "District",
      "headerTooltip": "The benchmarking page compares key KPIs with the market most relevant to you. Practical examples, tips and support for analysing the results can be found in our {knowledgeBase}.",
      "help": "Benchmarking help",
      "market": "Market",
      "marketLoadError": "The market settings could not be loaded.",
      "marketNotAvailableTooltip": "The market for your hotel has been analysed in advance and is pre-defined in an optimal way.",
      "marketSaveError": "The market settings could not be saved.",
      "marketSaveSuccess": "Market settings saved successfully.",
      "marketSettings": "Market settings",
      "marketTooltip": "No market has been defined yet. Please contact our support team.",
      "newPreset": "New",
      "noFilters": "No market",
      "presets": "Presets",
      "readOnlyMarketExplanation": "This market is maintained by RateBoard and is read-only for your hotel.",
      "region": "South Tyrolean\ntourism region",
      "retry": "Try again",
      "saveChanges": "Save changes",
      "state": "State",
      "title": "Benchmarking",
      "tourismRegion": {
        "AHRNTAL": "Ahrntal",
        "ALTA_BADIA": "Dolomites region Alta Badia",
        "BOZEN": "Bozen and surroundings",
        "BRIXEN": "Brixen and surroundings",
        "DREI_ZINNEN": "Dolomites region Three Peaks",
        "EGGENTAL": "Dolomites region Eggental",
        "GROEDEN": "Dolomites region Gröden",
        "KRONPLATZ": "Dolomites region Kronplatz",
        "MERAN": "Meran and surroundings",
        "NONE": "none",
        "SEISER_ALM": "Dolomites region Seiser Alm",
        "STERZING": "Sterzing and surroundings",
        "VILLNOESSTAL": "Dolomites region Villnöss Valley",
        "VINSCHGAU": "Vinschgau",
        "WEINSTRASSE": "South Tyrolean Wine Road"
      },
      "zipCode": "ZIP code"
    },
    "occupancyChart": {
      "title": "Occupancy"
    },
    "pickupAndCancellationsChart": {
      "labels": {
        "cancellation": "Your Cancellation",
        "cancellationMarket": "Market's Cancellation",
        "pickup": "Your Pickup",
        "pickupMarket": "Market's Pickup"
      },
      "title": "Pickup and Cancellation"
    },
    "pickupChart": {
      "title": "Pickup"
    },
    "stayDays": {
      "title": "Stay Dates for Pickup and Cancellation"
    },
    "upselling": {
      "activated": {
        "customize": "Customize your view with filters like country, hotel type, or star category, and benchmark yourself against the competitors that matter to you.",
        "stayTuned": "Stay tuned — feature will be released on <b>01.07.2025</b>, and you’ll be able to access powerful insights into your market. Track key figures like occupancy, ADR, pickup, and more to see how you compare.",
        "title": "Congrats! The benchmarking feature is activated"
      },
      "notActivated": {
        "alreadyRequested": "The feature has already been ordered. Please sign the digital contract we sent you via email. Benchmarking will then be activated.",
        "box": {
          "activate": "Activate and test now",
          "analyze": "Analyze KPIs such as occupancy, pickup & ADR",
          "comparison": "Compare with similar hotels",
          "customFilter": "Custom filters: region, hotel type, category & target group",
          "info": "You will receive the contract via email. Feature activation via signature.",
          "moreInformation": "More information",
          "questions": "If you have any questions, please contact us by phone or email <a href='mailto:support{'@'}rateboard.io'>support{'@'}rateboard.io</a>.",
          "resendContract": "Can't find the email? Simply click the button and receive the contract again:",
          "resendContractButton": "Resend contract",
          "revenuePotential": "Identify revenue potential",
          "signContract": "To complete the activation, please sign the contract that you received by email. The benchmarking function will only be available to you once you have successfully signed the contract.",
          "transparency": "The benchmarking module uses anonymised, aggregated data from many businesses - conclusions about individual hotels are excluded, including those regarding size or other specific information. You can opt out anytime by emailing <a href='mailto:support{'@'}rateboard.io'>support{'@'}rateboard.io</a>; in this case, the module will no longer be available.",
          "withdrawal": "Only {fee} - try during 7 days right of withdrawal",
          "withdrawalFee": "{fee}€/month"
        },
        "compareFigures": "Compare key figures such as occupancy, average rate, pickup and many more for future and past periods. Create customized comparisons based on freely selectable filters such as country, hotel type, star category, specific hotel focus and many more - compare yourself with who <b>you</b> want.",
        "identifyOpportunities": "Identify market opportunities for {company} and generate revenue, targeting high-demand periods.",
        "title": "Benchmarking",
        "underline": "Data Driven Decisions"
      },
      "timer": {
        "days": "Day | Days",
        "untilRelease": "until release"
      }
    }
  },
  "cancel": "Cancel",
  "clean": "Clean",
  "close": "Close",
  "companyValues": {
    "focus": {
      "AIRPORT": "Airport",
      "BUSINESS_TRIPS": "Business Trips",
      "CITY_TRIPS": "City Trips",
      "CONFERENCES": "Conferences",
      "CUISINE": "Cuisine",
      "FAMILY": "Family",
      "MOUNTAIN": "Mountain",
      "NATURE": "Nature",
      "WATER": "Water",
      "WELLNESS": "Wellness"
    },
    "segment": {
      "BUSINESS": "Business",
      "LEISURE": "Leisure",
      "LEISURE_BUSINESS": "Leisure & Business"
    },
    "stars": {
      "FIVE": "5 Stars",
      "FIVE_SUPERIOR": "5 Stars Superior",
      "FOUR": "4 Stars",
      "FOUR_SUPERIOR": "4 Stars Superior",
      "NOT_RATED": "Not Rated",
      "ONE": "1 Star",
      "THREE": "3 Stars",
      "THREE_SUPERIOR": "3 Stars Superior",
      "TWO": "2 Stars"
    }
  },
  "compare": "Compare",
  "connect": {
    "error": {
      "button": "Go to RateBoard",
      "message": "We couldn't connect Apaleo to RateBoard, contact your onboarding manager for more information.",
      "title": "Something went wrong!"
    },
    "pending": {
      "button": "Connect property",
      "message": "Before we continue, select the property you want to connect.",
      "title": "Almost there!"
    },
    "selectProperty": "Choose a property",
    "success": {
      "button": "Go to RateBoard",
      "message": "Your property was successfully connected. For more information, contact your onboarding manager.",
      "title": "You are connected!"
    }
  },
  "dashboard": {
    "baseWidget": {
      "filters": "Filters"
    },
    "chart": {
      "noData": "No data available",
      "week": "CW"
    },
    "createModal": {
      "cancel": "Cancel",
      "create": "Create dashboard",
      "errors": {
        "duplicate": "A dashboard with this name already exists.",
        "empty": "Enter a name.",
        "length": "40 characters maximum."
      },
      "fieldText": "Give your dashboard a unique name",
      "placeholder": "e.g. Weekly overview",
      "title": "New dashboard"
    },
    "emptyState": "You haven't added any widgets to this view yet. Click on “Add Widget” and add key metrics like RevPAR, Occupancy, or Pickup Revenue to monitor your performance at a glance.",
    "header": {
      "addWidget": "ADD WIDGET",
      "downloadPdf": "Download PDF",
      "pmsDataFreshness": {
        "label": "PMS data updated: {timestamp}",
        "tooltip": {
          "contactSupport": "Contact support",
          "message": "There is a problem with the data transfer."
        }
      },
      "widgetLimitReached": "You've reached the limit of {limit} widgets. Remove an existing widget to add a new one."
    },
    "switcher": {
      "copySuffix": "copy",
      "createNew": "Create new...",
      "dashboardLimitReached": "You've reached the limit of {limit} dashboards. Delete an existing dashboard to create a new one.",
      "default": "Default",
      "deleteDashboardModal": {
        "message": "You can't undo this action later. This will only affect your account.",
        "title": "Are you sure you want to delete {name} dashboard?"
      },
      "duplicateDashboard": "Duplicate Dashboard",
      "duplicateModal": {
        "label": "Dashboard Name"
      },
      "lastDashboardCannotBeDeleted": "This dashboard cannot be deleted, as there must be at least one dashboard.",
      "nameValidation": "Enter a unique dashboard name.",
      "newDashboardName": "Untitled Dashboard",
      "noDashboardSelected": "No dashboard selected"
    },
    "templateManagement": {
      "archive": "Archive",
      "archived": "Archived",
      "archiveMessage": "The template will no longer be available to users, and dashboards already created from it will not be affected. You can still access and publish it again later.",
      "archiveTitle": "Are you sure you want to archive {name} template?",
      "chooseFile": "Choose file",
      "copySuffix": "copy",
      "create": "Create template",
      "createAction": "Create template",
      "deleteMessage": "You can’t undo this action later. This will delete the template for all SUPER-ADMINS.",
      "deleteTitle": "Are you sure you want to delete {name} template?",
      "draft": "Draft",
      "duplicate": "Duplicate template",
      "duplicateAction": "Duplicate template",
      "edit": "Edit",
      "error": "The template could not be saved. Please try again.",
      "fields": "Template fields",
      "isOnboardingTemplate": "Onboarding template",
      "loading": "Loading templates...",
      "manage": "Manage templates",
      "nameDe": "German name",
      "nameEn": "English name",
      "nameIt": "Italian name",
      "newTemplate": "New template",
      "noThumbnail": "No file selected",
      "onboardingDefault": "Default for onboarding",
      "placeholderNames": {
        "de": "Neue Vorlage",
        "en": "New Template",
        "it": "Nuovo modello"
      },
      "publish": "Publish",
      "publishAction": "Publish template",
      "published": "Published",
      "publishMessage": "The template will be visible to all users.",
      "publishTitle": "Are you sure you want to publish {name} template?",
      "settings": "Settings",
      "thumbnail": "Thumbnail image",
      "thumbnailAvailable": "Thumbnail available",
      "thumbnailError": "The thumbnail could not be uploaded. Please try again.",
      "thumbnailRequired": "A thumbnail is required to publish a template.",
      "title": "Manage Templates",
      "unpublish": "Unpublish",
      "validation": "Enter unique names in German, English, and Italian.",
      "view": "View",
      "viewThumbnail": "View thumbnail"
    },
    "templatesModal": {
      "createNew": "Custom Dashboard",
      "subtitle": "Select an option to start building new Dashboard.",
      "title": "Templates"
    },
    "widgetLibrary": {
      "add": "Add",
      "header": {
        "cancel": "Cancel",
        "selectWidgets": "Select widgets to place on your dashboard"
      },
      "preview": {
        "notifications": {
          "bookings20Lower": "Bookings 20% lower",
          "revenue15Higher": "Revenue 15% higher"
        },
        "weather": {
          "city": "Innsbruck"
        }
      },
      "search": {
        "placeholder": "Search widgets..."
      },
      "title": "Widget Library",
      "widgetTypes": {
        "adr": "ADR",
        "all": "All widgets",
        "budgetGoal": "Budget Goal",
        "cancellation": {
          "revenue": "Revenue",
          "roomNights": "Room nights",
          "title": "Cancellation"
        },
        "market": "Market",
        "notification": "Notification",
        "occupancy": "Occupancy",
        "pickup": {
          "distribution": "Pickup Distribution",
          "revenue": "Gross Pickup Revenue",
          "revenueTotal": "NET PICKUP REVENUE",
          "roomNights": "Gross Pickup",
          "roomNightsTotal": "NET PICKUP",
          "title": "Pickup"
        },
        "rateAdjustment": "Rate Recommendations",
        "revenue": "Revenue",
        "review": "Review",
        "revPar": "RevPAR",
        "today": "Today",
        "weather": "Weather"
      }
    },
    "widgets": {
      "adr": {
        "title": "ADR",
        "tooltipKpi": "ADR"
      },
      "budgetGoal": {
        "differenceToGoal": "Difference to goal",
        "goalOccupancy": "Occupancy Goal",
        "goalRevenue": "Revenue Goal",
        "otbOccupancy": "Occupancy OTB",
        "otbRevenue": "Revenue OTB",
        "title": "Budget",
        "tooltipKpi": "OTB"
      },
      "cancellationRevenue": {
        "legendKpi": "Cancelled revenue",
        "title": "Cancelled revenue",
        "tooltipKpi": "Cancelled revenue"
      },
      "cancellationRoomNights": {
        "cancellations": "Cancellations",
        "title": "Cancelled Room Nights",
        "tooltipKpi": "Cancelled room nights"
      },
      "market": {
        "companyAverage": "My hotel",
        "differenceToMarket": "Difference to market",
        "infoTooltip": "Market values are real PMS data from hotels in your geographic benchmarking market. The regional forecast shows how demand is developing in your region.",
        "infoTooltipHeader": "NEW! Your occupancy compared to the market.",
        "marketAverage": "Market",
        "occupancy": "Occupancy",
        "occupancyThisMonth": "Occupancy this month",
        "regionalForecast": "Regional forecast",
        "title": "Market"
      },
      "notification": {
        "activated": "Activated {date}",
        "affectedDays": "{count} days affected from {from} to {to}",
        "noData": "You don't have active notifications, go to the Notifications page to manage them.",
        "title": "Notifications"
      },
      "occupancy": {
        "forecastTooltip": "Forecast",
        "title": "Occupancy",
        "tooltipKpi": "Occupancy"
      },
      "pickupDistribution": {
        "cancelledRoomnights": "Cancelled roomnights",
        "confirmedRoomnights": "Confirmed roomnights",
        "timeRange": {
          "custom": "from {from} - {to}",
          "lastDays": "from the last {count} days",
          "lastMonths": "from the last {count} months",
          "today": "from today",
          "yesterday": "from yesterday"
        },
        "title": "Pickup Distribution"
      },
      "pickupRevenue": {
        "title": "Gross Pickup Revenue",
        "tooltipKpi": "Gross Revenue Pickup"
      },
      "pickupRevenueTotal": {
        "cancelledLabel": "Cancelled Revenue",
        "netLegendLabel": "Net {year}",
        "netValueLabel": "PickUp Revenue",
        "pickupLabel": "Gross Pickup Revenue",
        "title": "NET PICKUP REVENUE",
        "tooltipKpi": "Revenue"
      },
      "pickupRoomNights": {
        "title": "Gross Pickup",
        "tooltipKpi": "Gross Pickup"
      },
      "pickupRoomNightsTotal": {
        "cancelledLabel": "Cancellations",
        "netLabel": "Gross Pickup",
        "netLegendLabel": "Net {year}",
        "netValueLabel": "Net Roomnights",
        "pickupLabel": "Gross Pickup",
        "title": "NET PICKUP",
        "tooltipKpi": "Roomnights"
      },
      "rateAdjustment": {
        "majorRateAdjustments": "Major rate adjustments",
        "noData": "There are no rate recommendations for the next 12 months. Check your settings to make sure everything is set up correctly.",
        "rateAdjustments": "Rate adjustments",
        "subtitle": "Next 12 months",
        "title": "Rate Recommendations"
      },
      "rateAdjustmentsCount": {
        "subtitle": "completed in last 7 days",
        "title": "Rate Adjustments"
      },
      "reference": "Reference",
      "revenue": {
        "forecastTooltip": "Forecast",
        "title": "Revenue",
        "tooltipKpi": "Revenue"
      },
      "reviews": {
        "average": "Average",
        "overallDistribution": "All-time distribution",
        "reviewsCount": "{count} reviews in the last 6 months",
        "title": "Reviews"
      },
      "revPar": {
        "title": "RevPAR",
        "tooltipKpi": "RevPAR"
      },
      "settings": {
        "cancel": "Cancel",
        "category": {
          "label": "Filter by"
        },
        "comparison": {
          "groups": {
            "final2YearsAgo": "FINAL 2 YEARS AGO",
            "finalLastYear": "FINAL LAST YEAR",
            "sameTime2YearsAgo": "SAME TIME 2 YEARS AGO",
            "sameTimeLastYear": "SAME TIME LAST YEAR"
          },
          "label": "Compare to",
          "options": {
            "custom": "Custom",
            "lastYear": "Last year",
            "none": "None chosen",
            "sameDate2YearsAgo": "Same Date YTD 2Y",
            "sameDate2YearsAgoFinal": "Same Date final 2Y",
            "sameDateLastYear": "Same Date YTD 1Y",
            "sameDateLastYearFinal": "Same Date final 1Y",
            "sameWeekday2YearsAgo": "Same Weekday YTD 2Y",
            "sameWeekday2YearsAgoFinal": "Same Weekday final 2Y",
            "sameWeekdayLastYear": "Same Weekday YTD 1Y",
            "sameWeekdayLastYearFinal": "Same Weekday final 1Y"
          }
        },
        "done": "Save",
        "kpi": {
          "label": "KPI",
          "options": {
            "occupancy": "Occupancy",
            "revenue": "Revenue"
          }
        },
        "majorDiff": {
          "label": "Major Diff",
          "tooltip": "Will display on the graph rate recommendations that are x% higher / lower than active rate.",
          "tooltipTitle": "Major Difference"
        },
        "rateType": {
          "label": "Rate type",
          "options": {
            "highest": "Highest",
            "lowest": "Lowest"
          }
        },
        "remove": "Remove",
        "size": {
          "label": "Size",
          "options": {
            "large": "Large",
            "medium": "Medium",
            "small": "Small"
          }
        },
        "timeRange": {
          "label": "Time range",
          "options": {
            "currentMonth": "Current month",
            "currentQuarter": "Current quarter",
            "currentWeek": "Current week",
            "currentYear": "Current year",
            "custom": "Custom",
            "last12Months": "Last 12 months",
            "last14Days": "Last 14 days",
            "last30Days": "Last 30 days",
            "last3Days": "Last 3 days",
            "last6Months": "Last 6 months",
            "last7Days": "Last 7 days",
            "last90Days": "Last 90 days",
            "next12Months": "Next 12 months",
            "next14Days": "Next 14 days",
            "next30Days": "Next 30 days",
            "next6Months": "Next 6 months",
            "next7Days": "Next 7 days",
            "next90Days": "Next 90 days",
            "today": "Today",
            "yesterday": "Yesterday"
          },
          "optionsSince": {
            "last12Months": "Last 12 months",
            "last14Days": "Last 14 days",
            "last30Days": "Last 30 days",
            "last6Months": "Last 6 months",
            "last7Days": "Last 7 days",
            "last90Days": "Last 90 days"
          }
        },
        "title": "Widget settings",
        "validation": {
          "dateRangeRequired": "Date range required"
        }
      },
      "timeRangeLabels": {
        "comparisonSubtitles": {
          "lastYear": "last year",
          "sameDate2YearsAgo": "2 years ago",
          "sameDateLastYear": "last year",
          "sameWeekday2YearsAgo": "2 years ago",
          "sameWeekdayLastYear": "last year",
          "twoYearsAgo": "2 years ago"
        },
        "differenceTo": "Compared to",
        "inThe": "In the",
        "subtitles": {
          "currentMonth": "This month",
          "currentQuarter": "This quarter",
          "currentWeek": "This calendar week",
          "currentYear": "This year",
          "last12Months": "last 12 months",
          "last14Days": "last 14 days",
          "last30Days": "last 30 days",
          "last6Months": "last 6 months",
          "last7Days": "last 7 days",
          "last90Days": "last 90 days",
          "next12Months": "next 12 months",
          "next14Days": "next 14 days",
          "next30Days": "next 30 days",
          "next6Months": "next 6 months",
          "next7Days": "next 7 days",
          "next90Days": "next 90 days"
        },
        "tooltipSubtitles": {
          "sameDate2YearsAgo": "same date (same time YTD 2Y)",
          "sameDate2YearsAgoFinal": "same date (final values)",
          "sameDateLastYear": "same date (same time YTD 1Y)",
          "sameDateLastYearFinal": "same date (final values)",
          "sameWeekday2YearsAgo": "same weekday (same time YTD 2Y)",
          "sameWeekday2YearsAgoFinal": "same weekday (final values)",
          "sameWeekdayLastYear": "same weekday (same time YTD 1Y)",
          "sameWeekdayLastYearFinal": "same weekday (final values)"
        }
      },
      "today": {
        "adr": "ADR",
        "cancellation": "Cancellations",
        "cancellationRevenue": "Cancellation Revenue",
        "netPickup": "Net Pickup",
        "netPickupRevenue": "Net Pickup Revenue",
        "occupancy": "Occupancy",
        "revenue": "Revenue",
        "revpar": "RevPAR",
        "subtitleToday": "Today",
        "title": "Today"
      },
      "weather": {
        "highLow": "H: {high}° L: {low}°",
        "noData": "No weather data available",
        "title": "Weather",
        "wind": "Wind: {speed}km/h"
      }
    }
  },
  "dataPrivacyAgreement": {
    "beforeAccessSign": "Before being able to access the hotel page, you need to sign the Data Processing Agreement (DPA) to ensure compliance with privacy regulations.",
    "canStillAccess": "You can still access other hotels you have been assigned to.",
    "notAccessUntilSigned": "Sorry, you can not access this hotel until the Data Processing Agreement (DPA) is sign by one of the hotel’s ADMIN users.",
    "readAndSign": "READ AND SIGN DPA"
  },
  "dataTable": {
    "empty": "No items to display.",
    "loading": "Loading...",
    "of": "of",
    "page": "Page",
    "perPage": "per page",
    "to": "to"
  },
  "deactivated": "Deactivated",
  "delete": "Delete",
  "dropdownSelect": {
    "all": "All",
    "empty": "Empty",
    "none": "None",
    "noneChosen": "None chosen",
    "nSelected": "{number} selected"
  },
  "error": "Error",
  "fileUploader": {
    "choose": "Choose a file",
    "dragAndDrop": "Drag and drop your file here or click to browse",
    "invalidFile": "The file is empty or in an incorrect format. Please upload a valid file.",
    "remove": "Remove file"
  },
  "filterPreset": {
    "modal": {
      "message": "Enter a unique name to save your preset for future usage",
      "title": "Save current filter as preset"
    },
    "newPreset": "New preset",
    "preset": "Preset",
    "presets": "Presets"
  },
  "footer": {
    "contact": {
      "title": "Contact us"
    },
    "support": {
      "times1": "Monday - Thursday, 8:00 - 17:00 CET",
      "times2": "Friday, 08:00 - 14:00 CET",
      "title": "Support times"
    }
  },
  "header": {
    "knowledgeBase": "Knowledge Base",
    "menu": {
      "administration": {
        "assistant": "Assistant",
        "connectivityStats": "Connectivity stats",
        "customerSuccessManagement": "CSM",
        "forecastControl": "Forecast Control",
        "hotelAdministration": "Administration",
        "inboundData": "Inbound Data",
        "monitoring": "Monitoring",
        "outboundLogs": "Outbound Logs",
        "rateEnginePOC": "RateEngine POC",
        "regionForecastControl": "Region Forecast Control",
        "reportsOverview": "Report Overview",
        "reservationOverview": "Res. Overview",
        "schedulers": "Schedulers",
        "users": "Users"
      },
      "analyse": {
        "analyse": "Analyse",
        "budget": "Budget",
        "comparison": "@:analyse.comparison.title",
        "competitors": "Competitors",
        "hotel": "@:analyse.hotel.title",
        "marketTrends": "Market-Trends",
        "pickUp": "PickUp",
        "reputation": "Reviews"
      },
      "settings": {
        "budgetConfiguration": "Budget Settings",
        "competitors": "Competitors",
        "events": "Events",
        "interfaceConfiguration": "Interface Configuration",
        "inventory": "Inventory",
        "notifications": "Notifications",
        "priceLevels": "Pricelevels",
        "ratePlans": "Rate Plans",
        "rateRounding": "Rate Rounding",
        "rateRules": "Rate Rules",
        "restrictions": "Restrictions",
        "roomPricingConfiguration": "Room Pricing Configuration",
        "segmentation": "Segmentation",
        "statusConfiguration": "Status Settings"
      },
      "title": {
        "activityLog": "Activity Log",
        "administration": "Administration",
        "analyse": "Analyse",
        "dashboard": "Dashboard",
        "manage": "Manage",
        "settings": "Settings"
      }
    },
    "releaseNotes": "Release Notes"
  },
  "hotelSelection": {
    "message": "Select a default company to be displayed when you log in to RateBoard. You can change it later in profile settings page.",
    "title": "Select default company"
  },
  "invitationConfirmation": {
    "allDone": "All Done!",
    "confirmInvitation": "Confirm your information so you can proceed and create your RateBoard account.",
    "createPassword": "Create password",
    "createPasswordSoLogin": "Create a password so you can log in to your RateBoard account.",
    "fields": {
      "acceptTerms": "Accept Terms of Use and Privacy Policy",
      "confirmPassword": "Confirm password",
      "password": "Password"
    },
    "goToLogin": "GO TO LOGIN PAGE",
    "hotelAssigned": "Hotel {company} has been successfully assigned to your RateBoard account. You can already login and access the hotel.",
    "invitationNotFound": {
      "message": "Please contact the person who sent the invite or our team if the problem persists.",
      "title": "Sorry, no invitation found."
    },
    "inviteAlreadyAccepted": "The invite was already accepted.",
    "invitedToJoin": "You have been invited to join Hotel {company}",
    "inviteExpired": "Sorry, this invite has expired",
    "somethingWrongHappened": "Sorry, something wrong happened",
    "submitLabel": "CREATE USER",
    "unableToCreate": "It seems that we were unable to create your account. You can try it again using the same link.",
    "unfortunatelyInviteExpired": "Please contact our support team at <a href='mailto:support{'@'}rateboard.io'>support{'@'}rateboard.io</a> to request a new link.",
    "validation": {
      "confirmPassword": "Passwords don't match",
      "email": "E-mail does not match with invitation",
      "password": "Password has to be atleast 8 characters long"
    }
  },
  "login": {
    "account": "Don't have an account?",
    "contactus": "Contact us",
    "error": {
      "blocked": "Too many incorrect login attempts. Account is blocked for 10 minutes!",
      "blockedNew": "For security reasons, your account is locked for 10 minutes due to multiple incorrect login attempts.",
      "browser": "Browser not supported!",
      "credentials": "Login not successful",
      "credentialsNew": "Sorry, we couldn’t login. Please check if you have the correct username and password. ",
      "noActiveCompany": "No active hotel assigned to user."
    },
    "forgotPassword": {
      "email": "Please check your email for further instructions!",
      "emailNew": "Check your inbox—we’ve sent you a password reset link. ",
      "forgot": "Forgot the password",
      "reset": {
        "button": "Reset",
        "buttonNew": "Send E-mail",
        "description": "We’ll send a password reset link to your email address.",
        "link": "Reset password"
      }
    },
    "login": "Login",
    "password": "password",
    "twoFactorAuthentication": {
      "authenticationDevice": "Can't use your authentication device?",
      "otpInputField": "6-digit code",
      "title": "Two-factor-authentication"
    },
    "username": "username",
    "usernameOrEmail": "Username or E-Mail Address"
  },
  "logout": "Logout",
  "maintenanceMode": {
    "message": "<b>RateBoard is currently in maintenance mode -</b><br> but don't worry — it'll be back up and running soon. We're making some improvements to bring you a better experience. Thank you for your patience!",
    "title": "We'll Be Back Soon!"
  },
  "manage": {
    "autopilot": {
      "description": "This feature automatically pushes recommended rates if they changed after re-computation.",
      "dialog": {
        "applyAll": "Apply these settings to all room categories.",
        "difference": "diff.",
        "from": "from",
        "fromTo1": "Only push rates for days between",
        "fromTo2": "days before arrival date.",
        "fromToEmpty": "From and To days before arrival date are required.",
        "fromToNegative": "From and To days before arrival date can't be negative.",
        "fromToOverlap": "From days can't be larger than To days.",
        "fromToRange": "From and To days before arrival date must be in range 0 - 540.",
        "lowerLimitLabel": "Set lower limit",
        "rateOffset1": "Accept",
        "rateOffset2": "HIGHER than",
        "rateOffset3": "LOWER than",
        "rateOffsetActiveRate": "Active rate",
        "rateOffsetBaseRate": "Base rate",
        "rateOffsetConnector": "",
        "rateOffsetConnectorNegativeAll": "",
        "rateOffsetConnectorNegativeLimit": "",
        "rateOffsetConnectorPositiveAll": "",
        "rateOffsetConnectorPositiveLimit": "",
        "rateOffsetEmpty": "The difference can't be empty.",
        "rateOffsetEnd": "",
        "rateOffsetKnowledgebaseLinkLabel": "Knowledgebase",
        "rateOffsetKnowledgebaseText": "A detailed documentation on the available settings can be found here:",
        "rateOffsetLimitNote": "If a rate recommendation exceeds the rate limits set for autopilot, it will still update the rate, up to the limit value.",
        "rateOffsetModeAllRates": "All rates",
        "rateOffsetModeNoRates": "No rates",
        "rateOffsetModeRatesUpTo": "Rates up to",
        "rateOffsetNegative": "The difference can't be negative.",
        "saveChanges": "Save changes",
        "to": "to",
        "upperLimitLabel": "Set upper limit"
      },
      "disabledTooltip": "Autopilot disabled",
      "enabledTooltip": "Autopilot enabled",
      "title": "Autopilot"
    },
    "calendar": {
      "day": {
        "autopilot": {
          "active": "Autopilot enabled",
          "fixedRate": "Rate fixed"
        },
        "closed": "Closed",
        "event": {
          "current": "Event this year",
          "past": "Event last year"
        },
        "modifications": {
          "algorithm": "Algorithm",
          "baseRate": "Base rate",
          "primaryRecommendation": "Primary recommendation",
          "rules": "Rules"
        },
        "rate": {
          "baseRateTooltip": "Base Rate plus Rate Rules (no algorithm)"
        },
        "rateSync": {
          "lastRate": "Last successfully sent rate"
        },
        "restriction": {
          "cta": "Closed to arrival",
          "ctd": "Closed to departure",
          "minLos": "Minimum length of stay in days"
        }
      }
    },
    "changeLog": {
      "applyPublish": "Apply and publish",
      "discardChanges": "Discard changes",
      "noChangesYet": "There are no changes recorded yet. If you edit rates in the calendar, these changes will appear here in the change log.",
      "responseCode": {
        "invalidRatePlanRoomCategories": "Some room categories in the Rate Plans that have no value! Please update them on the Settings/Rate Plans page.",
        "invalidRoomMapping": "Some rooms do not have a corresponding Channel Manager room type ID assigned.",
        "invalidRoomPrices": "Room pricing configuration is invalid.",
        "noApiUrl": "Interface URL not set.",
        "noHotelCode": "Hotel code is missing.",
        "noPms": "PMS not set for hotel.",
        "noRate": "There is no rate stored for at least one selected days. Cannot send update without rates.",
        "noRatePlan": "Rate plan not set.",
        "normalGuestCountTooLarge": "Number of standard guests too high. Please change in room pricing configuration.",
        "noRoomsMapped": "Room type mapping for interface missing.",
        "notMappedRooms": "There are some rooms that are never used by any interface (i.e. they are not mapped). The rates and restrictions will never be sent for them. Please go on the inventory page and archive these rooms.",
        "publishDisabled": "Publishing changes to any interface is disabled.",
        "ratesNotSaved": "Your rates could not be saved.",
        "restrictionsNotSaved": "Your restrictions could not be saved.",
        "roomTypePriceInvalid": "Room pricing configuration is invalid for room type {roomTypeName}.",
        "unexpected": "Your data could not be published, but we saved them in RateBoard.",
        "unknownError": "Internal server error."
      },
      "responseMessage": {
        "noRateLevel": "No rate level set.",
        "rateOutOfBounds": "Rate out of bounds."
      },
      "reviewedHint": "Have you performed all changes and reviewed closely?",
      "table": {
        "category": "Category",
        "closed": "Closed",
        "cta": "CTA",
        "ctd": "CTD",
        "details": "Details",
        "insteadOf": "instead of",
        "maxLos": "MaxLOS",
        "minLos": "MinLOS",
        "minLosOutOfRange": "Not all your PMS support MinLOS = {count}. You will not be able to see the same value on all your PMS!",
        "open": "Open",
        "rooms": "Rooms",
        "settingsRemoved": "Settings will be removed",
        "what": "What",
        "when": "When"
      },
      "title": "Change log",
      "types": {
        "rate": "Changed rate",
        "ratePlans": "Changed rate plans",
        "rateSettings": "Changed rate settings",
        "restrictions": "Changed restrictions"
      },
      "warning": "Warning",
      "warningMonthChange": "If you change months your changes will be lost! Do you want to continue?",
      "warningRefreshPage": "If you proceed, your changes will be lost! Do you want to continue?"
    },
    "editRates": "Edit rates",
    "nextMonth": "Next month",
    "noDaysSelected": "Currently, no days are selected or date from past is chosen. Select one or more days in the calendar in order to see more details or adjust rates.",
    "noRoomCategoryMapped": "No room categories mapped",
    "previousMonth": "Previous month",
    "recommendationStatus": {
      "completed": "Computation of rate recommendations completed.",
      "finished": "Rate computation in progress. This can take a few minutes.",
      "refreshRequired": "Refresh page to update rate recommendations",
      "title": "Recommendation Status"
    },
    "resync": {
      "button": "Resync data",
      "disabledHint": "Last resync is still active. Please try again later.",
      "errorLog": {
        "downloadAll": "Download all",
        "outOf": "{count1} of {count2} error(s)",
        "title": "Error log",
        "types": {
          "base": "General",
          "channel": "Channel",
          "rate": "Rate"
        }
      },
      "message": "Resend accepted room rates and active restrictions for the next 24 months to all connected PMS and CM.",
      "modal": {
        "hint1": {
          "part1": "The resync includes rates for the next 24 months, new restrictions, new settings in the room price configuration, new settings in the Rate Plans and new settings in the price levels (derivation of non primary room types). The resync ",
          "part2": "does not ",
          "part3": "accept new rate recommendations! ",
          "part4": "Important! ",
          "part5": "If you manually adjusted rates in the manage calendar, they will not be overwritten."
        },
        "hint2": {
          "part1": "Note: ",
          "part2": "This process can take some time and you won't be able to send new rates via the Rate calendar until it's completed. Please make sure you have finished your changes before starting the resync. Success or error message will be shown here and in the activity log after completion."
        },
        "message": "Are you sure you want to proceed? You are about to resend the accepted rates for all room types (including new settings) to all connected PMS and CM.",
        "title": "Resync"
      },
      "refresh": "Refresh",
      "resyncCompleted": "Resync completed",
      "resyncFailed": "Resync failed",
      "resyncFailedHint": "The resync failed, open the error log to check it in details.",
      "resyncInProgress": "In progress",
      "resyncInProgressHint": "This can take a while. You will be able to resync again or send new rates, via change log, once the process is done.",
      "title": "Resync"
    },
    "roomCategory": "Room category",
    "sidebar": {
      "autopilot": {
        "fixRates": "Fix rates",
        "forAllSelectedDays": "For all selected days",
        "hint1": {
          "message": "By activating this function you fix the current rate for the selected company. The Autopilot stays inactive on these days and rates have to be sent manually."
        },
        "noAutopilotMessage": "Autopilot is not active for at least one of the selected days.",
        "title": "Autopilot",
        "unfixRates": "Unfix rates"
      },
      "cancel": {
        "title": "Cancel"
      },
      "overview": {
        "competitors": {
          "cancellable": "Cancellable",
          "competitor": "Competitor",
          "empty": "There are no competitors for selected date.",
          "mealType": {
            "allInclusive": "All Inclusive",
            "breakfast": "Breakfast",
            "fullBoard": "Full Board",
            "halfBoard": "Half Board"
          },
          "title": "Competitors"
        },
        "events": {
          "empty": "There are no events for selected date.",
          "title": "Events"
        },
        "forCategory": "Category",
        "forHotel": "Hotel",
        "hint1": {
          "message": "More details about the occupancy, forecast, pickup and competitors can be found in the ",
          "messageLink": "support area",
          "messageStop": ".",
          "title": "Explanation"
        },
        "notes": {
          "addNew": "Add Note",
          "edit": "Edit note",
          "from": "From",
          "noteNotSaved": "Unable to save note. Please try again",
          "placeholder": "Your note",
          "title": "Notes",
          "to": "to",
          "warningDeletion": "This action cannot be undone! Are you sure you want to delete this note?"
        },
        "statistics": {
          "adr": "ADR",
          "forecastErrorCodes": {
            "calculationError": "Forecast calculation failed",
            "maximumDates": "Maximum 3 days can be selected",
            "onlyForHotel": "Forecast available only for whole company",
            "someInvalid": "No forecast for some of the selected days",
            "unexpected": "An unexpected error happened"
          },
          "forecastFinal": "Forecast/Final",
          "forSelectedDays": "Statistics for selected days",
          "groupBlocks": "Group blocks",
          "occupancy": "Occupancy",
          "occupancyBlocks": "Occupancy incl. Blocks",
          "pickup": "Today's pickup | Yesterday's pickup | Pickup {count} days",
          "revenue": "Revenue",
          "revPar": "RevPAR",
          "vacantRooms": "Vacant Rooms",
          "vacantRoomsBlocks": "Vacant Rooms incl. Blocks"
        },
        "title": "Overview"
      },
      "rateDescriptions": {
        "baseRate": "Base rate",
        "modifierTypes": {
          "derivation": "Derivation",
          "matrix": "Algorithm",
          "min": "Lower bound",
          "minMax": "Rate limit",
          "minMaxMax": "Rate limit MAX",
          "minMaxMin": "Rate limit MIN",
          "rateRounding": "Rounding",
          "rateRule": "Rule: {modifierName}",
          "rateRules": "Rules"
        },
        "primaryRecommendation": "Primary recommendation",
        "recommendedRate": "Recommended rate",
        "title": "Calculation"
      },
      "ratePlans": {
        "closed": "Closed",
        "closeOpen": "Close/open",
        "closeOpenDisabled": "The close/open status needs to be set in the PMS/CM directly.",
        "forAllCategories": "Apply to all room categories",
        "hint1": {
          "message": "Rate Plans are opened or closed with the door icon. Derivation from the base rate can be adjusted with a percentage or amount.",
          "title": "Step 1"
        },
        "hint2": {
          "message": "Review your changes in the log below the calendar.",
          "title": "Step 2"
        },
        "hint3": {
          "message": "Finally, you release the protocol with your changes.",
          "title": "Step 3"
        },
        "noChange": "No change",
        "open": "Open",
        "perPerson": "Per person",
        "perUnit": "Per unit",
        "title": "Rate Plans"
      },
      "rates": {
        "acceptAll": "Accept All",
        "acceptAllText": "Accept all suggestions",
        "adjust": "Adjust",
        "adjustment": "Adjustment",
        "allCategories": "All categories",
        "autopilotMessage": "Autopilot is active for at least one of the selected days. To manage the rates manually, please first fix the rates for these days.",
        "baseRates": "Base rates",
        "default": "Default",
        "forCategory": "Category",
        "forHotel": "Hotel",
        "hint1": {
          "message": "Temporarily save the changed rates in order to view it in the calendar and protocol.",
          "title": "Step 1"
        },
        "hint2": {
          "message": "Verify your changes in the protocol which you find below the calendar.",
          "title": "Step 2"
        },
        "hint3": {
          "message": "Send the rates to your active channels.",
          "title": "Step 3"
        },
        "hint4": {
          "message": "By modifying the primary rate, all dependent room types get updated as well. You can also override the derivation of each room type.",
          "title": "Change rates"
        },
        "hint5": {
          "message": "By modifying the primary rate, all dependent room types get updated as well.",
          "message2": "Rates will only be updated on days and in categories WITHOUT active Autopilot.",
          "title": "Change rates"
        },
        "notSet": "Not set",
        "rateStatus": {
          "baseInvalid": "Base rate is not within the price level range.",
          "basePriceLevelMissing": "Missing price level.",
          "checkChangeLog": "Changes saved in the change log for review.",
          "derivedInvalid1": "Rate out of range for",
          "derivedInvalid2": "room type.",
          "derivedPriceLevelMissing1": "Missing price level for",
          "derivedPriceLevelMissing2": "room type.",
          "error": "Error",
          "success": "Success"
        },
        "restoreDefault": "Restore default",
        "title": "Rates"
      },
      "restrictions": {
        "closed": "Closed",
        "cta": "Closed to arrival (CTA)",
        "ctd": "Closed to departure (CTD)",
        "current": "Current",
        "forAllCategories": "Apply these settings to all room categories",
        "hint1": {
          "message": "Temporarily save the changed restrictions in order to view it in the calendar and protocol.",
          "title": "Step 1"
        },
        "hint2": {
          "message": "Verify your changes in the protocol which you find below the calendar.",
          "title": "Step 2"
        },
        "hint3": {
          "message": "Send the restrictions to your connected systems.",
          "title": "Step 3"
        },
        "maxLos": "Maximum length of stay (MaxLOS)",
        "minLos": "Minimum length of stay (MinLOS)",
        "new": "New",
        "notSet": "Not set",
        "notSupported": "This restriction is not supported by any of your PMS or CM.",
        "notSupportedEnabled": "This restriction is not supported/enabled by any of your PMS or CM.",
        "open": "Open",
        "outOfRange": "MinLOS cannot be higher than MaxLOS!",
        "setToZero": "If you set MinLOS or MaxLOS to zero, this restriction will be removed completely.",
        "title": "Restrictions",
        "upTo": "up to"
      }
    },
    "smallScreen": {
      "message1": "Looks like you are seeing the calendar on a smaller screen.",
      "message2": "In order to guarantee optimal visibility and editability the calendar will be displayed only for higher resolutions.",
      "title": "Small screen"
    },
    "title": "Rate calendar",
    "today": "Today"
  },
  "marketTrends": {
    "chartHeader": {
      "amountOfSearches": "Amount of searches",
      "userLocationMap": "User location",
      "weeklySearchTrends": "Weekly search trends",
      "yearlySearchTrends": "Yearly search trends"
    },
    "chartLabel": {
      "weeklySearchTrends": {
        "for": "Weekday searched for",
        "on": "Search made on weekday"
      },
      "yearlySearchTrends": {
        "current": "Current year",
        "forecast": "Forecast",
        "past": "Past year"
      }
    },
    "from": "From",
    "gridItem": {
      "ninety": {
        "title": "Total Search",
        "underline": "Last 90 days"
      },
      "thirty": {
        "title": "Total Search",
        "underline": "Last 30 days"
      },
      "trending": {
        "title": "Currently Trending",
        "trendingMonth13": "Easter",
        "trendingMonth14": "New Year"
      }
    },
    "newUi": {
      "amountOfSearchesTooltip": "Shows the daily number of searches for the selected area and date range.",
      "weeklySearch": "Weekly Search",
      "yearlySearchTrend": "Yearly Search Trend"
    },
    "pageHeader": {
      "dateRange": "Searches from-to",
      "title": "Market Trends"
    },
    "regionOfInterest": {
      "country": "Country",
      "label": "Searches at:",
      "region": "Province",
      "zip": "Municipality"
    },
    "to": "to"
  },
  "modal": {
    "title": {
      "add": "Add"
    }
  },
  "netGrossSwitch": {
    "gross": "Gross",
    "label": "Revenue:",
    "net": "Net",
    "tooltip": "Selection will change inbound revenue data from net to gross (and vice versa). Values only change for pages showing this switch."
  },
  "next": "Next",
  "no": "No",
  "notifications": {
    "banner": {
      "later": "Later",
      "title": "You have new system alerts"
    },
    "notifications": "Notifications",
    "panel": {
      "empty": "Looks like everything is done"
    },
    "payload": {
      "unmappedRoomTypesCount": "You have one unmapped room type. Please map it to a category in the inventory settings. | You have {count} unmapped room types. Please map them to a category in the inventory settings.",
      "unmappedSegmentsCount": "You have one unmapped segment | You have {count} unmapped segments"
    },
    "solveNow": "Solve now",
    "systemAlerts": "System alerts",
    "tag": {
      "roomType": {
        "unmappedRoomTypes": "Unmapped room types"
      },
      "segment": {
        "unmappedSegments": "Unmapped segments"
      }
    }
  },
  "ok": "OK",
  "pageHeader": {
    "datesText": "Logged changes from-to:"
  },
  "pageNotFound": {
    "error": "Error {status}",
    "errorMessage": {
      "401": "Oops! You don't have permission to view this page. Please make sure you are logged in.",
      "403": "Sorry, you don’t have the necessary permissions to view this page. Please contact support for further assistance.",
      "404": "Oh no! The page you are looking for doesn’t exist.",
      "500": "Sorry, something went wrong on our end. Please try again later.",
      "503": "Sorry, we're having technical difficulties at the moment. Please try again later.",
      "NoActiveHotel": "No active hotel assigned to user. Please contact your support manager for more information."
    },
    "goToDashboard": "Go to dashboard",
    "redirectMessage1": "You will be redirected to the dashboard in",
    "redirectMessage2": "seconds."
  },
  "pickup": {
    "distribution": {
      "graph": {
        "otb": "OTB",
        "roomNightsCancelled": "Room nights cancelled",
        "roomNightsConfirmed": "Room nights confirmed"
      },
      "header": "PickUp Distribution",
      "table": {
        "cancellations": "Cancellations",
        "cancellationsRevenue": "Cancellations Revenue",
        "currentLabel": "Range",
        "month": "Month",
        "otb": "OTB",
        "otbRevenue": "OTB Revenue",
        "pickup": "Pickup",
        "pickupRevenue": "Pickup Revenue",
        "referenceLabel": "Reference",
        "roomNights": "Room Nights",
        "totalRevenue": "Total Revenue",
        "vacantRooms": "Vacant Rooms"
      },
      "tooltips": {
        "graph": "Displays how the KPI for the selected date range is distributed across future days/months.",
        "graphHeader": "PickUp Distribution Graph",
        "table": "Displays the summed up results month by month.",
        "tableHeader": "PickUp Distribution Table"
      }
    },
    "filters": {
      "cancelledPickup": {
        "label": "Cancelled PickUp",
        "options": {
          "hide": "Hide",
          "show": "Show"
        }
      },
      "datePicker": {
        "label": "Date Range",
        "ranges": {
          "last14Days": "Last 14 days",
          "last7Days": "Last 7 days",
          "lastMonth": "Last month",
          "thisMonth": "This month",
          "thisWeek": "This week"
        },
        "tooltip": "Select a date range of up to 1 year."
      },
      "groupBy": {
        "label": "Group by",
        "options": {
          "none": "None",
          "roomCategory": "Room category",
          "segment": "Segment"
        },
        "tooltip": "Grouping by segmentation is only supported, if the segmentation categorization is activated for your hotel. (find them in Settings > Segmentation)"
      },
      "kpi": {
        "label": "KPI",
        "options": {
          "revenue": "Revenue",
          "roomNights": "Room Nights"
        }
      },
      "reference": {
        "label": "Reference",
        "options": {
          "none": "None chosen",
          "previous2Years": "2 Years ago",
          "previousYear": "Last Year",
          "sameDate": "Same date",
          "sameDateOfWeek": "Same day of week"
        }
      }
    },
    "from": "From",
    "pageHeader": "PickUp",
    "pickupPerDay": {
      "errorMessages": {
        "failedToFetchData": "We were not able to load the necessary data. Please try again later.",
        "noData": "No data available for the selected filters. Try a different combination."
      },
      "graph": {
        "cancelled": "Cancelled",
        "confirmed": "Confirmed",
        "gained": "Gained",
        "reference": "Reference",
        "referenceCancelled": "Reference cancelled",
        "referenceConfirmed": "Reference confirmed",
        "referenceGained": "Reference gained",
        "referenceRevenue": "Reference revenue",
        "referenceRoomNights": "Reference room nights",
        "revenue": "Revenue",
        "revenueCancelled": "Revenue cancelled",
        "revenueGained": "Revenue gained",
        "roomCategoryData": {
          "apartment": "Apartment",
          "budget": "Budget",
          "family": "Family",
          "single": "Single",
          "standard": "Standard",
          "suite": "Suite",
          "superior": "Superior"
        },
        "roomNights": "Room nights",
        "roomNightsCancelled": "Room nights cancelled",
        "roomNightsConfirmed": "Room nights confirmed",
        "segmentData": {
          "complimentary": "Complimentary",
          "group": "Group",
          "groupType": {
            "complimentary": "isComplimentary",
            "group": "isGroup",
            "none": "none"
          },
          "none": "Regular"
        }
      },
      "header": "PickUp per Day",
      "table": {
        "adr": "ADR",
        "cancellations": "Cancellations",
        "cancellationsRevenue": "Cancellations Revenue",
        "group": "Group",
        "pickup": "Pickup",
        "pickupRevenue": "Pickup Revenue",
        "roomNights": "Room Nights",
        "totalRevenue": "Total Revenue"
      },
      "tooltips": {
        "graph": "Displays the selected KPI spread across the date range. The KPI can still be split by groups.",
        "graphHeader": "PickUp per Day Graph",
        "table": "Displays the summed up results for each group, if selected.",
        "tableHeader": "PickUp per Day Table"
      }
    },
    "summary": {
      "header": "Summary",
      "titles": {
        "adr": "ADR",
        "cancellations": "Cancellations",
        "pickupRoomNight": "PickUp",
        "revenue": "Total Revenue"
      },
      "tooltips": {
        "adr": "Displays the ADR for the selected date range, and compares it with the selected reference.",
        "cancellations": "Displays the cancellations for the selected date range, and compares it with the selected reference.",
        "headerTooltip": "Displays the summed up results for the selected filters.",
        "pickupRoomNight": "Displays the pickup room nights for the selected date range, and compares it with the selected reference.",
        "revenue": "Displays the revenue for the selected date range, and compares it with the selected reference."
      }
    },
    "to": "to"
  },
  "report": "Report",
  "reputation": {
    "averageRate": {
      "title": "Average rate",
      "tooltip": "Average score in the last 6 months."
    },
    "business": {
      "title": "Business",
      "tooltip": "Average all time score based on business guests."
    },
    "couples": {
      "title": "Couples",
      "tooltip": "Average all time score based on couples guests."
    },
    "family": {
      "title": "Family",
      "tooltip": "Average all time score based on family guests."
    },
    "goodToKnow": "Good to Know",
    "highlights": {
      "title": "Highlights",
      "tooltip": "Most relevant topics about your hotel based on your guests reviews."
    },
    "metaReview": "Meta Review",
    "nationality": {
      "title": "Nationality",
      "tooltip": "Review distribution based on traveler’s nationality."
    },
    "noReviews": "No reviews available",
    "overallDistribution": {
      "title": "Overall Distribution",
      "tooltip": "How your guests are distributed by the categories: score, type and language."
    },
    "overallScore": {
      "averageScore": "/5",
      "last6Months": "Last 6 months",
      "reviews": "reviews",
      "title": "Overall Score",
      "tooltip": "Average all time score of your hotel, based on guests category."
    },
    "pageHeader": "Reviews",
    "poweredBy": "powered by",
    "rateDistribution": {
      "title": "Rate distribution",
      "tooltip": "Review distribution based on score."
    },
    "relevantNow": {
      "title": "Relevant now",
      "tooltip": "How your hotel was evaluated in the past 6 months."
    },
    "reviewCount": {
      "reviews": "Reviews",
      "title": "Review Count",
      "tooltip": "Monthly amount of reviews in the last 6 months."
    },
    "reviewLevel": "Review Level",
    "scorePerCategory": {
      "noReviews": "No reviews available for this category.",
      "summary": "Summary",
      "title": "Score per Category",
      "tooltip": "Average score and useful information about the most important categories for your hotel."
    },
    "social": "Social",
    "solo": {
      "title": "Solo",
      "tooltip": "Average all time score based on solo guests."
    },
    "summary": "Summary",
    "topScore": "Top Score",
    "traveler": {
      "title": "Traveler",
      "tooltip": "Review distribution based on traveler type."
    }
  },
  "resetPassword": {
    "alert": {
      "success": "New password set. Login into your account."
    }
  },
  "save": "Save",
  "search": "Search",
  "segmentation": {
    "descriptionOne": "This tool can be used to categorize reservations based on their segments. Segments are maintained in the hotel software / PMS and transferred to RateBoard. The segmentation influences the rate recommendations (Complimentary bookings and group bookings do not count towards demand).",
    "descriptionOneNew": "This tool can be used to categorize reservations based on their segments as relevant or unrelevant for demand calculation. The <b>segmentation type influences the rate recommendation, as \"complimentary\" and \"group\" bookings are not considered in demand.</b>",
    "descriptionTwo": "If this function is active, each (new) segment must be mapped, the selection of 'Complimentary', 'Group' or 'None' is mandatory for each category.",
    "descriptionTwoNew": "Segments are maintained in the hotel software/ PMS and transferred to RateBoard. Once segmentation is enabled, <b>all segments must be mapped as \"none\", \"complimentary\" or \"group\".</b>",
    "noSegments": "No segments",
    "noSegmentsTooltip": "Can't be activated because there are no segments.",
    "tableHeaders": {
      "complimentary": "Complimentary",
      "group": "Group",
      "none": "None",
      "segment": "PMS Segment",
      "segmentationType": "Segmentation Type"
    },
    "title": "Segmentation",
    "toggleButton": "Segmentation On/Off"
  },
  "select": {
    "empty": "Empty",
    "notSet": "Not set"
  },
  "session": {
    "expired": {
      "continue": "Continue using RateBoard",
      "logout": "Logout",
      "message": "We didn't register any activity for some time and in order to keep your account safe we will log you out automatically. If you want to stay logged in, please click 'Continue using RateBoard'",
      "title": "Your session is about to expire"
    }
  },
  "settings": {
    "interface": {
      "apaleo": "APALEO",
      "channelManager": {
        "add": "Add Channel Manager",
        "addNew": "Add new CM",
        "amountOfChannelsReached": "Maximum number of channels reached.",
        "channelManager": "Channel Manager",
        "channelNotSaved": "You didn't save this channel. Unable to add new channel.",
        "configuration": "CM Configuration",
        "importUsersNotDisabled": "Please disable all active import users or delete current FTP user before changing PMS or removing channel.",
        "integration": "Integration",
        "integrations": "Your Integrations",
        "integrationsLabel": "Integrations",
        "newIntegration": "New CM Integration",
        "remove": "Remove Channel"
      },
      "cmIntegration": "CM-Integration",
      "crawler": {
        "button": "RE-IMPORT",
        "message": "Are you sure you want to start crawler? Select a new start date or use the default (2 years).",
        "modalTitle": "Start Crawler",
        "title": "CRAWLER"
      },
      "credentials": {
        "address": "API URL",
        "apiToken": "API Token",
        "connect": "Connect",
        "disconnect": "Disconnect",
        "disconnectMessage": "Do you want to disconnect from the interface?",
        "errorMessageValid": "All Fields are required.",
        "hotelCode": "Hotel Code",
        "idToken": "ID Token",
        "notConnected": "Not connected",
        "password": "Password",
        "save": "Save changes",
        "saveMessage": "Do you want to save the interface credentials?",
        "title": "Default credentials",
        "username": "Username"
      },
      "ftpCrawler": {
        "button": "RE-IMPORT",
        "message": "Are you sure you want to start ftp crawler?",
        "modalTitle": "Start Crawler",
        "title": "ftp crawler"
      },
      "ftpImportCredentials": {
        "generate": "Generate FTP user",
        "title": "Ftp import credentials"
      },
      "importCredentials": {
        "active": "Active",
        "alert": {
          "create": {
            "error": "New user could not be generated.",
            "success": "New user generated."
          },
          "delete": {
            "error": "User was not deleted.",
            "success": "User deleted."
          },
          "disable": {
            "error": "Credential was not disabled.",
            "success": "Credential disabled."
          },
          "enable": {
            "error": "Credential was not activated.",
            "success": "Credential was activated."
          }
        },
        "disabled": "Disabled",
        "generate": "Generate User",
        "modal": {
          "delete": "This action can not be undone. Are you sure that you want to DELETE user {username}",
          "disable": "Are you sure you want to DISABLE user {username}, this action will stop the imports using this credential.",
          "generate": {
            "password": "Password",
            "title": "Generate New User",
            "username": "Username",
            "warning": "Warning",
            "warningText": "The password will be hidden after this step, please write it down before moving on."
          }
        },
        "newUiGenerate": "Generate import user",
        "title": "Import credentials"
      },
      "inbound": {
        "generalInformation": "General Information",
        "guaranteeType": "Guarantee Type for options",
        "importInventoryFromPMS": "Import inventory from PMS",
        "title": "Inbound Configuration"
      },
      "interfaceConfiguration": "Interface Configuration",
      "outbound": {
        "ageCategories": "Age Categories",
        "ageQualifyingCode": "Age Qualifying Code",
        "allFieldsRequired": "All Fields are required.",
        "applyTo": "Apply to",
        "chargeType": "Charge Type",
        "externalSettingsFetchingError": "There was a problem while fetching external Room Types/Rate Plans. Are the credentials correct?",
        "generalInformation": "General Information",
        "ignored": "Ignored",
        "maxLos": "Maxlos",
        "mealPlan": {
          "allInclusive": "All Inclusive",
          "bedAndBreakfast": "Bed & Breakfast",
          "fullBoard": "Full Board",
          "halfBoard": "Half Board",
          "mealType": "Meal Type",
          "roomOnly": "Room Only"
        },
        "minLos": "Minlos",
        "noActiveRatePlans": "At least one Rate Plan per interface should be always activated.",
        "noActiveRoomTypes": "Please map at least one room type.",
        "noActiveRoomTypesRatePlans": "Please map at least one room type for the activated Rate Plan.",
        "noMappedMealPlan": "Meal type mapping is missing for the activated Rate Plans.",
        "noMappedRatePlanTitle": "Mapping is missing for the activated Rate Plans.",
        "noMappedRoomTypeTitle": "No room types mapped.",
        "perPerson": "Per Person",
        "perRoom": "Per Room",
        "productCode": "Product code",
        "publish": "Publish data",
        "ratePlanCategory": "Rate Plan Category",
        "ratePlanCategoryCode": "rate plan category code",
        "ratePlanCode": "rate plan code",
        "ratePlans": "Rate Plans",
        "restrictionsSettings": "Restriction settings",
        "roomType": "Room Type",
        "roomTypes": "Room Types",
        "title": "Outbound Configuration"
      },
      "pmsConfiguration": "PMS Configuration",
      "pmsIntegration": "PMS-Integration",
      "pmsSelection": {
        "pms": "PMS"
      },
      "restrictions": {
        "closed": "Closed",
        "cta": "Closed to Arrival (CTA)",
        "ctd": "Closed to Departure (CTD)",
        "maxLos": "MaxLOS",
        "minLos": "MinLOS",
        "title": "Supported restrictions"
      }
    },
    "inventory": {
      "capacity": {
        "addButton": {
          "newUiText": "New capacity",
          "text": "Add..."
        },
        "addModal": {
          "message": "Select the start date for the new room capacity. From this date onward, the updated number of rooms will be used.",
          "submit": "Add new capacity",
          "title": "Add room capacity"
        },
        "cardTitle": "Capacity",
        "changeDateDialog": {
          "message": "Select the new start date from which this room capacity will apply.",
          "newUiTitle": "Edit capacity start date",
          "title": "Change date"
        },
        "datePicker": {
          "changeDate": "Change date",
          "fromLabel": "From:",
          "label": "Date:"
        },
        "deleteImpossibleTooltipText": "Can not remove last inventory or last inventory with date 3 years before today",
        "deleteModal": {
          "message": "Are you sure you want to delete this room capacity? This action can't be undone.",
          "title": "Delete capacity"
        },
        "details": "Details",
        "error": {
          "collidingDate": "There is already an entry with date {date}.",
          "threeYearsRequired": "At least one inventory record with a date 3 years ago or older is required.",
          "totalAtLeastOne": "The total number of rooms needs to be at least 1."
        },
        "manualSettingNotPossible": {
          "text": "We are importing the capacity information directly from the PMS. The manual capacity configuration is disabled.",
          "title": "Manual setting of capacity is not possible."
        },
        "options": "Options",
        "roomsAndCount": "Rooms and count",
        "totalAvailable": {
          "label": "Total:",
          "newUiLabel": "Total rooms:"
        }
      },
      "configuration": {
        "confirmationMessage1": "Changing the assignment of room types <> room categories leads to the following changes in the price levels:",
        "confirmationMessage2": "Price levels with derivations in % from the primary type will ALL be automatically changed to the corresponding value in € amounts.",
        "confirmationMessage3": "If this is not desired, please cancel this process and contact our support team at ",
        "confirmationMessage4": ". Price levels with derivations in € from the primary type remain the same in the base.",
        "confirmationMessage5": "Please check your minimum and maximum values after saving and adjust them if necessary.",
        "errorMessage": "Please make sure that all fields contain values and you set strictly one primary room for each category!",
        "excludedRooms": "Excluded rooms",
        "newUiConfirmationMessage2": "Price levels <b>with derivations in %</b> from the primary type <b>will ALL be automatically changed to the corresponding value in € amounts</b>.",
        "newUiConfirmationMessage3": "Price levels with derivations in € from the primary type remain the same in the base.",
        "options": "Options",
        "pmsTitle": "List of all PMS room types",
        "priceWarning": "Changing of \"Primary Type\" or \"Category\" may cause price level settings to become incorrect for some of the rooms. Please check your price level settings afterwards!!!",
        "roomBlocksSwitch": "Consider group blocks",
        "roomTypeCreation": {
          "addRoomType": "Add room type",
          "button": "Add room type",
          "duplicateName": "A room type with this name already exists, try a different name.",
          "duplicateNameErrorMessage": "RoomType already exists",
          "modalContent": "Are you sure you want to create a room type? Make sure you add a meaningful name.",
          "modalTitle": "Add new room type",
          "newUiModalTitle": "Add room type",
          "placeholder": "ROOMX"
        },
        "showExcludedRooms": "Show excluded rooms",
        "table": {
          "category": "Category",
          "options": {
            "active": "Active",
            "archived": "Archived",
            "excluded": "Excluded",
            "header": "Options"
          },
          "primary": "Primary Type",
          "roomType": "Room Type"
        },
        "unresolvableWarning": "Could not re-compute one or more overriden price settings on following days: {dates}. Overrides will be deleted. Do you want to continue?",
        "warningTitle": "ATTENTION!"
      },
      "tabs": {
        "capacity": "Capacity",
        "configuration": "Configuration"
      },
      "title": "Inventory"
    },
    "notificationRules": {
      "conditions": {
        "adr": {
          "summaryAverage": "ADR is {operator} {value} for {category} on average",
          "summaryDaily": "ADR is {operator} {value} for {category} on all days"
        },
        "autopilot": {
          "increaeOrDecrease": "increase or decrease rate more than",
          "summary": "Autopilot increase or decrease rate more than {deviation}"
        },
        "availability": {
          "summaryAverage": "{operator} {available} rooms are available on average in {category}",
          "summaryDaily": "{operator} {available} rooms are available daily in {category}"
        },
        "cancellation": {
          "moreThan": "More than",
          "roomsFor": "rooms cancelled in the last",
          "summary": "More than {value} rooms cancelled in the last {days}"
        },
        "capping": {
          "comparables": {
            "maximum": "maximum",
            "minimum": "minimum"
          },
          "summary": "Capping {comparable} value is reached for a running future period of {days}",
          "valueIsReached": "value is reached for a running future period of",
          "valueIsReachedAfter": "",
          "valueIsReachedBefore": ""
        },
        "categoryConstraints": {
          "comparables": {
            "higher": "higher",
            "lower": "lower"
          },
          "is": "is",
          "rateOf": "Rate of",
          "summary": "Rate of {categoryId1} is {comparable} than {categoryId2}",
          "than": "than"
        },
        "dateRange": {
          "summaryShort": "{dateFrom} - {dateTo}"
        },
        "dba": {
          "summaryShort": "{from} days > DBA < {to} days"
        },
        "occupancy": {
          "summaryAverage": "Occupancy is {operator} {value}% for {category} on average",
          "summaryDaily": "Occupancy is {operator} {value}% for {category} on all days"
        },
        "pickup": {
          "roomsFor": "rooms pickup in the last",
          "summary": "{operator} {value} rooms pickup in the last {days}"
        },
        "rateLevel": {
          "undefined": "Pricelevel (ID={id})"
        },
        "rateRecommendation": {
          "deviatesMore": "deviates more than",
          "fromTheActive": "from the active rate.",
          "summary": "Rate recommendation deviates more than {deviation} from the active rate"
        },
        "revpar": {
          "summaryAverage": "RevPAR is {operator} {value} for {category} on average",
          "summaryDaily": "RevPAR is {operator} {value} for {category} on all days"
        },
        "types": {
          "autopilot": "Autopilot",
          "cancellation": "Cancellation",
          "capping": "Capping",
          "categoryConstraints": "Category constraints",
          "pickup": "Pickup",
          "rateRecommendation": "Rate recommendation",
          "yoyComparison": "YoY comparison"
        },
        "yoyComparison": {
          "are": "are",
          "comparables": {
            "higher": "higher",
            "lower": "lower"
          },
          "compareTo": "Compare to",
          "comparisonDays": {
            "sameDate": "same date",
            "sameWeekday": "same day of week"
          },
          "dataTypes": {
            "adr": "ADR",
            "availability": "Vacant rooms",
            "booking": "OTB Bookings",
            "cancellations": "Cancellations",
            "occupancy": "Occupancy",
            "pickup": "Pickup",
            "revenue": "OTB Revenue",
            "revPar": "RevPar"
          },
          "is": "is",
          "summaryAverage": "{dataType} {isOrAre} {deviation} {comparable} on average compared to last year. Compare to {comparisonDay}",
          "summaryAveragePickupOrCancellation": "{dataType} {isOrAre} {deviation} {comparable} on average compared to last year for the last {days}. Compare to {comparisonDay}",
          "summaryDaily": "{dataType} {isOrAre} {deviation} {comparable} daily compared to last year. Compare to {comparisonDay}",
          "summaryDailyPickupOrCancellation": "{dataType} {isOrAre} {deviation} {comparable} daily compared to last year for the last {days}. Compare to {comparisonDay}",
          "thanLastYear": "than last year.",
          "thanLastYearForARunningPeriodOf": "than last year for the last"
        }
      },
      "createRule": "Create new notification",
      "createRuleNew": "New Notification",
      "days": "{n} days",
      "deleteRule": {
        "title": "Delete notification"
      },
      "description": "Create custom notifications for this hotel, exclusive to your account - activate up to {n} at a time",
      "editCreateRule": {
        "conditions": {
          "summary": "If the following conditions ...",
          "title": "Conditions ({n}/{max})",
          "titleTooltip": "Combine up to {n} conditions. The notification triggers when all conditions are met."
        },
        "createRule": "Create notification",
        "editRule": "Edit notification",
        "invalidTimeRange": "At least DBA or Date Range needs to be set",
        "notificationType": {
          "summary": "notify me via",
          "title": "Notification type",
          "titleTooltip": "Choose to be notified via the app on the Dashboard or via email."
        },
        "ruleName": "Notification name",
        "ruleNameTooltip": "You can rename the notification later. Choose a name that clearly describes its purpose.",
        "summaryLabels": {
          "for": "For",
          "if": "If"
        },
        "timeRange": {
          "add": "Add time range",
          "summary": "apply during this period ...",
          "title": "Time range ({n}/{max})",
          "titleTooltip": "At least one DBA or Date Range needs to be added. Time Range condition of same type can not be combined."
        },
        "valueProvingType": {
          "buttonTemplate": "{type} value",
          "label": "Value proving type",
          "labelTooltip": "Pick whether to evaluate each day individually or use the average for the selected time range."
        }
      },
      "notificationRuleTable": {
        "actions": "Actions",
        "conditions": "Conditions amount",
        "conditionsAmountString": "{n}/{max}",
        "name": "Notification name",
        "notificationTypes": "Notification type",
        "status": "Status",
        "statusTooltip": "You can have up to {n} active rules.",
        "timeRangeConditions": "Time range",
        "tooltip": {
          "delete": "Delete rule",
          "edit": "Edit rule",
          "ruleActive": "Rule active",
          "ruleInactive": "Rule inactive"
        }
      },
      "notificationTypes": {
        "types": {
          "dashboard": "In-app",
          "email": "E-mail"
        },
        "undefined": {
          "summary": "No notification type set yet"
        }
      },
      "runChecks": "Run checks",
      "timeRanges": {
        "dateRange": {
          "exceeded": "This notification’s date range is outdated. Adjust it to keep getting notified."
        },
        "undefined": {
          "summary": "No time range set yet"
        }
      },
      "title": "Notifications",
      "toast": {
        "activationFailed": "We couldn’t activate this notification. Please try again later or reach out to our support team if the issue continues.",
        "activationOk": "The notification has been activated.",
        "changesFailed": "We couldn’t save your changes. Please try again later or contact our support team if the issue continues.",
        "changesOk": "Your changes have been saved.",
        "deactivationFailed": "We couldn’t deactivate this notification. Please try again later or contact our support team if the issue continues.",
        "deactivationOk": "The notification has been deactivated.",
        "deleteFailed": "We couldn’t delete this notification. Please try again later or contact our support team if the issue continues.",
        "deleteOk": "The notification has been deleted.",
        "maxActive": "You’ve reached the limit of {n} active rules. Please disable an existing rule before activating this one."
      },
      "valueProvingTypes": {
        "types": {
          "average": "average",
          "daily": "daily"
        }
      }
    },
    "rateRounding": {
      "methods": {
        "up": "Round up to",
        "up_down": "Round up or down to",
        "up_down_multiples": "Round up or down to multiples of",
        "up_multiples": "Round up to multiples of"
      },
      "noRounding": "Don't round",
      "title": "Rate rounding"
    },
    "rateRules": {
      "actions": {
        "directions": {
          "decrease": "decrease",
          "increase": "increase"
        },
        "rate": {
          "rateBy": "rate by",
          "summary": "{direction} rate by {value} for {category}"
        },
        "undefined": {
          "summary": "No action set yet"
        }
      },
      "category": {
        "allCategories": "all categories",
        "customCategory": "Category (ID={id})",
        "for": "for"
      },
      "computeRecommendations": "Compute recommendations",
      "conditions": {
        "adr": {
          "summary": "ADR is {operator} {value} for {category}"
        },
        "are": "are",
        "availability": {
          "areVacantFor": "are vacant for",
          "rooms": "rooms",
          "summary": "{operator} {available} rooms are vacant for {category}"
        },
        "competitors": {
          "comparables": {
            "average": "average",
            "highest": "highest",
            "lowest": "lowest"
          },
          "mine": "mine.",
          "ratesOf": "rates of",
          "summary": "{comparable} rates of {category} are {offset}{operator} mine"
        },
        "dateRange": {
          "maxDiffTooltip": "Range must not exceed a time range of {n} days.",
          "summary": "Date range is from {dateFrom} to {dateTo}"
        },
        "dba": {
          "and": "and",
          "fromHigherTo": "Lower DBA bound cannot be higher than upper DBA bound.",
          "isBetween": "is between",
          "maxDbaDiffExceeded": "DBA range must not exceed a time range of {n} days.",
          "maxDbaExceeded": "This condition can evaluate up to {n} days.",
          "maxDbaTooltip": "The time to be evaluated can go up to {n} days in the future.",
          "summary": "DBA is between {from} and {to} days"
        },
        "event": {
          "notSet": "not set",
          "onTheDate": "on the date.",
          "set": "set",
          "summary": "Event is {set} on the date"
        },
        "is": "is",
        "occupancy": {
          "summary": "Occupancy is {operator} {occupancy}% for {category}"
        },
        "of": "of",
        "rateLevel": {
          "isActiveFor": "is active for",
          "summary": "Pricelevel '{rateLevel}' is active for {category}"
        },
        "revPar": {
          "summary": "RevPAR is {operator} {revPar} for {category}"
        },
        "types": {
          "adr": "ADR (Average Daily Rate)",
          "availability": "Vacant rooms",
          "competitors": "Competitors",
          "dateRange": "Date range",
          "dba": "DBA (Days Before Arrival)",
          "event": "Event",
          "occupancy": "Occupancy",
          "rateLevel": "Pricelevel",
          "revPar": "RevPAR (Revenue per available room)",
          "weatherForecast": "Weather forecast",
          "weatherTemperature": "Temperature",
          "weatherWindSpeed": "Wind speed",
          "weekday": "Weekdays"
        },
        "undefined": {
          "summary": "No conditions set yet"
        },
        "weatherForecast": {
          "comparables": {
            "cloudy": "cloudy",
            "misty": "misty",
            "rainy": "rainy",
            "snowy": "snowy",
            "sunny": "sunny"
          },
          "onAffectedDay": "on affected day.",
          "summary": "Weather forecast is {comparable} on affected day"
        },
        "weatherTemperature": {
          "comparables": {
            "average": "average",
            "maximum": "maximum",
            "minimum": "minimum"
          },
          "summary": "{comparable} temperature is {operator} {temperature}",
          "temperatureIs": "temperature is"
        },
        "weatherWindSpeed": {
          "summary": "Wind speed is {operator} {windSpeed}",
          "windSpeedIs": "Wind speed is"
        },
        "weekday": {
          "summaryMany": "Weekdays are {weekdays} and {lastWeekday}",
          "summaryOne": "Weekday is {weekday}"
        }
      },
      "createRule": "Create new rule",
      "createRuleNew": "New rate rule",
      "deleteRule": {
        "message": "This action cannot be undone! Are you sure you want to remove this rule?",
        "title": "Delete rule"
      },
      "description": "Create rules to adjust your hotel’s rate recommendations. Rules are applied to the recommendations calculated by the algorithm.",
      "descriptionTwo": "You can activate up to {n} rules.",
      "editCreateRule": {
        "actions": {
          "add": "Add action",
          "summary": "... execute the following actions:",
          "title": "Actions",
          "titleTooltip": "Add up to {n} actions to the rule, if the conditions are met, all the actions will be executed."
        },
        "conditions": {
          "add": "Add condition",
          "none": "None",
          "summary": "If the following conditions apply ...",
          "title": "Conditions",
          "titleTooltip": "Add up to {n} conditions to the rule, all the conditions will have to be met so the actions can be executed."
        },
        "createRule": "Create new rule",
        "editRule": "Edit rule",
        "invalid": "You need at least a rule name, one condition and one action to save a rule. You can add a maximum of {nC} conditions and {nA} actions.",
        "ruleName": "Rule name",
        "ruleNameTooltip": "You can change the rule's name later. Choose a name that clearly describe the new rule.",
        "summary": "Summary"
      },
      "hotelOrCategory": {
        "category": "Room category",
        "hotel": "Hotel"
      },
      "operators": {
        "equalTo": "equal to",
        "lessThan": "less than",
        "moreThan": "more than",
        "noLessThan": "no less than",
        "noMoreThan": "no more than"
      },
      "rateRule": {
        "accumulating": {
          "description": "All rules in this section are active and will be executed if the conditions are met.",
          "title": "Accumulating rules"
        },
        "activeSince": "Active since {dateTime}",
        "and": "and",
        "create": "create",
        "hierarchical": {
          "description": "All rules in this section are active. Rules are proved in hierarchical order. You can reorder by drag and drop. The first rule meeting the conditions is applied. All lower-ranked rules are skipped.",
          "title": "Hierarchical rules"
        },
        "inactive": {
          "description": "New and inactive rules are stored in this section. Drag any rule to the desired section (accumulating or hierarchical) to activate it. Drag the rule back to this section to deactivate it.",
          "title": "Inactive rules"
        },
        "nActions": "{n} actions|{n} action|{n} actions",
        "nConditions": "{n} conditions|{n} condition|{n} conditions",
        "notDraggable": "Maximum number of active rules reached"
      },
      "rateRuleContainer": {
        "order": "{order}°"
      },
      "title": "Rate Rules",
      "toast": {
        "computationRequestOk": "Recommendations are being calculated. This might take a couple of minutes."
      }
    }
  },
  "sidebar": {
    "emptyPlaceHolder": "Nothing to display here!"
  },
  "submit": "Submit",
  "termsOfUse": {
    "message": "Before using RateBoard please read and accept our Terms of Use and Privacy Policy. You can find them here:",
    "messageNew": "Before using RateBoard, read and accept our Terms of Use and Privacy Policy. ",
    "title": "Terms of Use"
  },
  "userSettings": {
    "accountSettings": {
      "defaultCompany": "Open on start",
      "defaultCompanyTooltip": "Choose a default company to be displayed when RateBoard is started.",
      "language": "Language",
      "locale": "Format",
      "locales": {
        "AT": "Austrian",
        "CH": "Swiss",
        "DE": "German",
        "FI": "Finnish",
        "FR": "French",
        "GB": "English (GB)",
        "IT": "Italian",
        "US": "English (US)"
      },
      "localeTooltip": "The date and currency format are set according to the selected region. This does not affect the property's region.",
      "title": "Account Settings"
    },
    "changePassword": {
      "confirmPassword": "Re-enter new password",
      "confirmPasswordPlaceholder": "Confirm password",
      "invalidOld": "Invalid old password!",
      "newPassword": "New password",
      "newPasswordPlaceholder": "New password",
      "notMatching": "Passwords do not match!",
      "oldPassword": "Old password",
      "oldPasswordPlaceholder": "Password",
      "save": "Save new password",
      "subtitle": "Choose new password",
      "title": "Choose new password",
      "titleNew": "Change Password",
      "tooShort": "Invalid password. The password must be at least 8 characters long and may contain special characters, but no spaces."
    },
    "overview": "Overview",
    "reports": {
      "frequency": {
        "DAILY": "Daily",
        "MONTHLY": "Monthly",
        "NEVER": "Never",
        "WEEKLY": "Weekly"
      },
      "performanceReport": "Performance report",
      "pickupReport": "Pickup report",
      "rateReport": "Rate report",
      "title": "Reports"
    },
    "resetPassword": {
      "title": "Reset password"
    },
    "saveChanges": "Save changes",
    "savePassword": "Change password",
    "security": "Security Settings",
    "title": "User Settings",
    "twoFactorAuthentication": {
      "addDevice": "Add device",
      "addDeviceError": "Unable to add a 2FA device.",
      "addDeviceSuccess": "2FA device added successfully.",
      "disabled": "Disabled",
      "enabled": "Enabled",
      "otpInputField": "6-digit code",
      "otpInvalid": "Invalid code, please try again",
      "otpMessage": "Enter a code from your authentication app to make sure everything is working. Once connected, we'll remember this device, so you can use it when logging in.",
      "otpTitle": "Verify authentication app",
      "password": "Password",
      "passwordInvalid": "Wrong password, please try again",
      "qrCodeAccountName": "Account name: ",
      "qrCodeManual": "Or enter the code to your verification app manually",
      "qrCodeManualCode": "Code: ",
      "qrCodeMessage": "Scan this QR code with a security or authentication app such as Google Authenticator, Authy, Duo or any other trusted app available on your device's app store.",
      "qrCodeTitle": "Scan QR code with authentication app",
      "removeDevice": "remove device",
      "removeDeviceError": "Unable to remove the 2FA device.",
      "removeDeviceMessage": "Enter your RateBoard password to remove and disable this device as two-factor authentication. This action can not be undone, but you can add a new device later.",
      "removeDeviceSuccess": "2FA device removed and disabled successfully.",
      "removeDeviceTitle": "Remove two-factor authentication",
      "setupMessage": "Enter your RateBoard password to start the setup.",
      "setupTitle": "Setup two-factor authentication",
      "title": "Two-factor authentication",
      "tooltip": "Maximum one device can be connected"
    },
    "user": {
      "title": "User Settings",
      "userMail": "User e-mail"
    }
  },
  "validation": {
    "email": "Not a valid E-mail",
    "max": "Exceeded max number of characters",
    "min": "Minimum number of characters not met",
    "required": "Required"
  },
  "warning": {
    "warning": "Warning!",
    "warningDeletion": "This action cannot be undone! Are you sure you want to remove this item?",
    "warningUnsavedChanges": "You have unsaved changes. If you continue your changes will be lost!"
  },
  "yes": "Yes"
}
